import {
  type LucideIcon,
  AArrowDownIcon,
  AArrowUpIcon,
  ALargeSmallIcon,
  AccessibilityIcon,
  ActivityIcon,
  AirVentIcon,
  AirplayIcon,
  AlarmClockIcon,
  AlarmCheckIcon,
  AlarmClockMinusIcon,
  AlarmClockOffIcon,
  AlarmClockPlusIcon,
  AlarmSmokeIcon,
  AlbumIcon,
  AlignCenterIcon,
  AlignCenterHorizontalIcon,
  AlignCenterVerticalIcon,
  AlignEndHorizontalIcon,
  AlignEndVerticalIcon,
  AlignHorizontalDistributeCenterIcon,
  AlignHorizontalDistributeEndIcon,
  AlignHorizontalDistributeStartIcon,
  AlignHorizontalJustifyCenterIcon,
  AlignHorizontalJustifyEndIcon,
  AlignHorizontalJustifyStartIcon,
  AlignHorizontalSpaceAroundIcon,
  AlignHorizontalSpaceBetweenIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  AlignStartHorizontalIcon,
  AlignStartVerticalIcon,
  AlignVerticalDistributeCenterIcon,
  AlignVerticalDistributeEndIcon,
  AlignVerticalDistributeStartIcon,
  AlignVerticalJustifyCenterIcon,
  AlignVerticalJustifyEndIcon,
  AlignVerticalJustifyStartIcon,
  AlignVerticalSpaceAroundIcon,
  AlignVerticalSpaceBetweenIcon,
  AmbulanceIcon,
  AmpersandIcon,
  AmpersandsIcon,
  AnchorIcon,
  AngryIcon,
  AnnoyedIcon,
  AntennaIcon,
  AnvilIcon,
  ApertureIcon,
  AppWindowIcon,
  AppWindowMacIcon,
  AppleIcon,
  ArchiveIcon,
  ArchiveRestoreIcon,
  ArchiveXIcon,
  AreaChartIcon,
  ArmchairIcon,
  ArrowBigDownIcon,
  ArrowBigDownDashIcon,
  ArrowBigLeftIcon,
  ArrowBigLeftDashIcon,
  ArrowBigRightIcon,
  ArrowBigRightDashIcon,
  ArrowBigUpIcon,
  ArrowBigUpDashIcon,
  ArrowDownIcon,
  ArrowDown01Icon,
  ArrowDown10Icon,
  ArrowDownAZIcon,
  ArrowDownFromLineIcon,
  ArrowDownLeftIcon,
  ArrowDownNarrowWideIcon,
  ArrowDownRightIcon,
  ArrowDownToDotIcon,
  ArrowDownToLineIcon,
  ArrowDownUpIcon,
  ArrowDownWideNarrowIcon,
  ArrowDownZAIcon,
  ArrowLeftIcon,
  ArrowLeftFromLineIcon,
  ArrowLeftRightIcon,
  ArrowLeftToLineIcon,
  ArrowRightIcon,
  ArrowRightFromLineIcon,
  ArrowRightLeftIcon,
  ArrowRightToLineIcon,
  ArrowUpIcon,
  ArrowUp01Icon,
  ArrowUp10Icon,
  ArrowUpAZIcon,
  ArrowUpDownIcon,
  ArrowUpFromDotIcon,
  ArrowUpFromLineIcon,
  ArrowUpLeftIcon,
  ArrowUpNarrowWideIcon,
  ArrowUpRightIcon,
  ArrowUpToLineIcon,
  ArrowUpWideNarrowIcon,
  ArrowUpZAIcon,
  ArrowsUpFromLineIcon,
  AsteriskIcon,
  AtSignIcon,
  AtomIcon,
  AudioLinesIcon,
  AudioWaveformIcon,
  AwardIcon,
  AxeIcon,
  Axis3DIcon,
  BabyIcon,
  BackpackIcon,
  BadgeIcon,
  BadgeAlertIcon,
  BadgeCentIcon,
  BadgeCheckIcon,
  BadgeDollarSignIcon,
  BadgeEuroIcon,
  BadgeHelpIcon,
  BadgeIndianRupeeIcon,
  BadgeInfoIcon,
  BadgeJapaneseYenIcon,
  BadgeMinusIcon,
  BadgePercentIcon,
  BadgePlusIcon,
  BadgePoundSterlingIcon,
  BadgeRussianRubleIcon,
  BadgeSwissFrancIcon,
  BadgeXIcon,
  BaggageClaimIcon,
  BanIcon,
  BananaIcon,
  BanknoteIcon,
  BarChartIcon,
  BarChart2Icon,
  BarChart3Icon,
  BarChart4Icon,
  BarChartBigIcon,
  BarChartHorizontalIcon,
  BarChartHorizontalBigIcon,
  BarcodeIcon,
  BaselineIcon,
  BathIcon,
  BatteryIcon,
  BatteryChargingIcon,
  BatteryFullIcon,
  BatteryLowIcon,
  BatteryMediumIcon,
  BatteryWarningIcon,
  BeakerIcon,
  BeanIcon,
  BeanOffIcon,
  BedIcon,
  BedDoubleIcon,
  BedSingleIcon,
  BeefIcon,
  BeerIcon,
  BeerOffIcon,
  BellIcon,
  BellDotIcon,
  BellElectricIcon,
  BellMinusIcon,
  BellOffIcon,
  BellPlusIcon,
  BellRingIcon,
  BetweenHorizonalEndIcon,
  BetweenHorizonalStartIcon,
  BetweenVerticalEndIcon,
  BetweenVerticalStartIcon,
  BikeIcon,
  BinaryIcon,
  BiohazardIcon,
  BirdIcon,
  BitcoinIcon,
  BlendIcon,
  BlindsIcon,
  BlocksIcon,
  BluetoothIcon,
  BluetoothConnectedIcon,
  BluetoothOffIcon,
  BluetoothSearchingIcon,
  BoldIcon,
  BoltIcon,
  BombIcon,
  BoneIcon,
  BookIcon,
  BookAIcon,
  BookAudioIcon,
  BookCheckIcon,
  BookCopyIcon,
  BookDashedIcon,
  BookDownIcon,
  BookHeadphonesIcon,
  BookHeartIcon,
  BookImageIcon,
  BookKeyIcon,
  BookLockIcon,
  BookMarkedIcon,
  BookMinusIcon,
  BookOpenIcon,
  BookOpenCheckIcon,
  BookOpenTextIcon,
  BookPlusIcon,
  BookTextIcon,
  BookTypeIcon,
  BookUpIcon,
  BookUp2Icon,
  BookUserIcon,
  BookXIcon,
  BookmarkIcon,
  BookmarkCheckIcon,
  BookmarkMinusIcon,
  BookmarkPlusIcon,
  BookmarkXIcon,
  BoomBoxIcon,
  BotIcon,
  BotMessageSquareIcon,
  BotOffIcon,
  BoxIcon,
  BoxSelectIcon,
  BoxesIcon,
  BracesIcon,
  BracketsIcon,
  BrainIcon,
  BrainCircuitIcon,
  BrainCogIcon,
  BrickWallIcon,
  BriefcaseIcon,
  BriefcaseBusinessIcon,
  BriefcaseMedicalIcon,
  BringToFrontIcon,
  BrushIcon,
  BugIcon,
  BugOffIcon,
  BugPlayIcon,
  BuildingIcon,
  Building2Icon,
  BusIcon,
  BusFrontIcon,
  CableIcon,
  CableCarIcon,
  CakeIcon,
  CakeSliceIcon,
  CalculatorIcon,
  CalendarIcon,
  CalendarCheckIcon,
  CalendarCheck2Icon,
  CalendarClockIcon,
  CalendarDaysIcon,
  CalendarFoldIcon,
  CalendarHeartIcon,
  CalendarMinusIcon,
  CalendarMinus2Icon,
  CalendarOffIcon,
  CalendarPlusIcon,
  CalendarPlus2Icon,
  CalendarRangeIcon,
  CalendarSearchIcon,
  CalendarXIcon,
  CalendarX2Icon,
  CameraIcon,
  CameraOffIcon,
  CandlestickChartIcon,
  CandyIcon,
  CandyCaneIcon,
  CandyOffIcon,
  CannabisIcon,
  CaptionsIcon,
  CaptionsOffIcon,
  CarIcon,
  CarFrontIcon,
  CarTaxiFrontIcon,
  CaravanIcon,
  CarrotIcon,
  CaseLowerIcon,
  CaseSensitiveIcon,
  CaseUpperIcon,
  CassetteTapeIcon,
  CastIcon,
  CastleIcon,
  CatIcon,
  CctvIcon,
  CheckIcon,
  CheckCheckIcon,
  ChefHatIcon,
  CherryIcon,
  ChevronDownIcon,
  ChevronFirstIcon,
  ChevronLastIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  ChevronsDownIcon,
  ChevronsDownUpIcon,
  ChevronsLeftIcon,
  ChevronsLeftRightIcon,
  ChevronsRightIcon,
  ChevronsRightLeftIcon,
  ChevronsUpIcon,
  ChevronsUpDownIcon,
  ChromeIcon,
  ChurchIcon,
  CigaretteIcon,
  CigaretteOffIcon,
  CircleIcon,
  AlertCircleIcon,
  ArrowDownCircleIcon,
  ArrowLeftCircleIcon,
  ArrowDownLeftFromCircleIcon,
  ArrowDownRightFromCircleIcon,
  ArrowUpLeftFromCircleIcon,
  ArrowUpRightFromCircleIcon,
  ArrowRightCircleIcon,
  ArrowUpCircleIcon,
  CheckCircle2Icon,
  CheckCircleIcon,
  ChevronDownCircleIcon,
  ChevronLeftCircleIcon,
  ChevronRightCircleIcon,
  ChevronUpCircleIcon,
  CircleDashedIcon,
  CircleDivideIcon,
  CircleDollarSignIcon,
  CircleDotIcon,
  CircleDotDashedIcon,
  CircleEllipsisIcon,
  CircleEqualIcon,
  CircleFadingPlusIcon,
  CircleGaugeIcon,
  CircleHelpIcon,
  CircleMinusIcon,
  CircleOffIcon,
  CircleParkingIcon,
  CircleParkingOffIcon,
  CirclePauseIcon,
  CirclePercentIcon,
  CirclePlayIcon,
  CirclePlusIcon,
  CirclePowerIcon,
  CircleSlashIcon,
  CircleSlash2Icon,
  CircleStopIcon,
  CircleUserIcon,
  CircleUserRoundIcon,
  CircleXIcon,
  CircuitBoardIcon,
  CitrusIcon,
  ClapperboardIcon,
  ClipboardIcon,
  ClipboardCheckIcon,
  ClipboardCopyIcon,
  ClipboardListIcon,
  ClipboardMinusIcon,
  ClipboardPasteIcon,
  ClipboardEditIcon,
  ClipboardPenLineIcon,
  ClipboardPlusIcon,
  ClipboardTypeIcon,
  ClipboardXIcon,
  ClockIcon,
  Clock1Icon,
  Clock10Icon,
  Clock11Icon,
  Clock12Icon,
  Clock2Icon,
  Clock3Icon,
  Clock4Icon,
  Clock5Icon,
  Clock6Icon,
  Clock7Icon,
  Clock8Icon,
  Clock9Icon,
  CloudIcon,
  CloudCogIcon,
  CloudDownloadIcon,
  CloudDrizzleIcon,
  CloudFogIcon,
  CloudHailIcon,
  CloudLightningIcon,
  CloudMoonIcon,
  CloudMoonRainIcon,
  CloudOffIcon,
  CloudRainIcon,
  CloudRainWindIcon,
  CloudSnowIcon,
  CloudSunIcon,
  CloudSunRainIcon,
  CloudUploadIcon,
  CloudyIcon,
  CloverIcon,
  ClubIcon,
  CodeIcon,
  Code2Icon,
  CodepenIcon,
  CodesandboxIcon,
  CoffeeIcon,
  CogIcon,
  CoinsIcon,
  Columns2Icon,
  Columns3Icon,
  Columns4Icon,
  CombineIcon,
  CommandIcon,
  CompassIcon,
  ComponentIcon,
  ComputerIcon,
  ConciergeBellIcon,
  ConeIcon,
  ConstructionIcon,
  ContactIcon,
  Contact2Icon,
  ContainerIcon,
  ContrastIcon,
  CookieIcon,
  CookingPotIcon,
  CopyIcon,
  CopyCheckIcon,
  CopyMinusIcon,
  CopyPlusIcon,
  CopySlashIcon,
  CopyXIcon,
  CopyleftIcon,
  CopyrightIcon,
  CornerDownLeftIcon,
  CornerDownRightIcon,
  CornerLeftDownIcon,
  CornerLeftUpIcon,
  CornerRightDownIcon,
  CornerRightUpIcon,
  CornerUpLeftIcon,
  CornerUpRightIcon,
  CpuIcon,
  CreativeCommonsIcon,
  CreditCardIcon,
  CroissantIcon,
  CropIcon,
  CrossIcon,
  CrosshairIcon,
  CrownIcon,
  CuboidIcon,
  CupSodaIcon,
  CurrencyIcon,
  CylinderIcon,
  DatabaseIcon,
  DatabaseBackupIcon,
  DatabaseZapIcon,
  DeleteIcon,
  DessertIcon,
  DiameterIcon,
  DiamondIcon,
  DiamondMinusIcon,
  DiamondPercentIcon,
  DiamondPlusIcon,
  Dice1Icon,
  Dice2Icon,
  Dice3Icon,
  Dice4Icon,
  Dice5Icon,
  Dice6Icon,
  DicesIcon,
  DiffIcon,
  DiscIcon,
  Disc2Icon,
  Disc3Icon,
  DiscAlbumIcon,
  DivideIcon,
  DnaIcon,
  DnaOffIcon,
  DockIcon,
  DogIcon,
  DollarSignIcon,
  DonutIcon,
  DoorClosedIcon,
  DoorOpenIcon,
  DotIcon,
  DownloadIcon,
  DraftingCompassIcon,
  DramaIcon,
  DribbbleIcon,
  DrillIcon,
  DropletIcon,
  DropletsIcon,
  DrumIcon,
  DrumstickIcon,
  DumbbellIcon,
  EarIcon,
  EarOffIcon,
  EarthIcon,
  EarthLockIcon,
  EclipseIcon,
  EggIcon,
  EggFriedIcon,
  EggOffIcon,
  EllipsisIcon,
  EllipsisVerticalIcon,
  EqualIcon,
  EqualNotIcon,
  EraserIcon,
  EuroIcon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FacebookIcon,
  FactoryIcon,
  FanIcon,
  FastForwardIcon,
  FeatherIcon,
  FenceIcon,
  FerrisWheelIcon,
  FigmaIcon,
  FileIcon,
  FileArchiveIcon,
  FileAudioIcon,
  FileAudio2Icon,
  FileAxis3DIcon,
  FileBadgeIcon,
  FileBadge2Icon,
  FileBarChartIcon,
  FileBarChart2Icon,
  FileBoxIcon,
  FileCheckIcon,
  FileCheck2Icon,
  FileClockIcon,
  FileCodeIcon,
  FileCode2Icon,
  FileCog2Icon,
  FileDiffIcon,
  FileDigitIcon,
  FileDownIcon,
  FileHeartIcon,
  FileImageIcon,
  FileInputIcon,
  FileJsonIcon,
  FileJson2Icon,
  FileKeyIcon,
  FileKey2Icon,
  FileLineChartIcon,
  FileLockIcon,
  FileLock2Icon,
  FileMinusIcon,
  FileMinus2Icon,
  FileMusicIcon,
  FileOutputIcon,
  FileEditIcon,
  FilePenLineIcon,
  FilePieChartIcon,
  FilePlusIcon,
  FilePlus2Icon,
  FileQuestionIcon,
  FileScanIcon,
  FileSearchIcon,
  FileSearch2Icon,
  FileSlidersIcon,
  FileSpreadsheetIcon,
  FileStackIcon,
  FileSymlinkIcon,
  FileTerminalIcon,
  FileTextIcon,
  FileTypeIcon,
  FileType2Icon,
  FileUpIcon,
  FileVideoIcon,
  FileVideo2Icon,
  FileVolumeIcon,
  FileVolume2Icon,
  FileWarningIcon,
  FileXIcon,
  FileX2Icon,
  FilesIcon,
  FilmIcon,
  FilterIcon,
  FilterXIcon,
  FingerprintIcon,
  FireExtinguisherIcon,
  FishIcon,
  FishOffIcon,
  FishSymbolIcon,
  FlagIcon,
  FlagOffIcon,
  FlagTriangleLeftIcon,
  FlagTriangleRightIcon,
  FlameIcon,
  FlameKindlingIcon,
  FlashlightIcon,
  FlashlightOffIcon,
  FlaskConicalIcon,
  FlaskConicalOffIcon,
  FlaskRoundIcon,
  FlipHorizontalIcon,
  FlipHorizontal2Icon,
  FlipVerticalIcon,
  FlipVertical2Icon,
  FlowerIcon,
  Flower2Icon,
  FocusIcon,
  FoldHorizontalIcon,
  FoldVerticalIcon,
  FolderIcon,
  FolderArchiveIcon,
  FolderCheckIcon,
  FolderClockIcon,
  FolderClosedIcon,
  FolderCog2Icon,
  FolderDotIcon,
  FolderDownIcon,
  FolderGitIcon,
  FolderGit2Icon,
  FolderHeartIcon,
  FolderInputIcon,
  FolderKanbanIcon,
  FolderKeyIcon,
  FolderLockIcon,
  FolderMinusIcon,
  FolderOpenIcon,
  FolderOpenDotIcon,
  FolderOutputIcon,
  FolderEditIcon,
  FolderPlusIcon,
  FolderRootIcon,
  FolderSearchIcon,
  FolderSearch2Icon,
  FolderSymlinkIcon,
  FolderSyncIcon,
  FolderTreeIcon,
  FolderUpIcon,
  FolderXIcon,
  FoldersIcon,
  FootprintsIcon,
  ForkliftIcon,
  ForwardIcon,
  FrameIcon,
  FramerIcon,
  FrownIcon,
  FuelIcon,
  FullscreenIcon,
  GalleryHorizontalIcon,
  GalleryHorizontalEndIcon,
  GalleryThumbnailsIcon,
  GalleryVerticalIcon,
  GalleryVerticalEndIcon,
  GamepadIcon,
  Gamepad2Icon,
  GanttChartIcon,
  GaugeIcon,
  GavelIcon,
  GemIcon,
  GhostIcon,
  GiftIcon,
  GitBranchIcon,
  GitBranchPlusIcon,
  GitCommitHorizontalIcon,
  GitCommitVerticalIcon,
  GitCompareIcon,
  GitCompareArrowsIcon,
  GitForkIcon,
  GitGraphIcon,
  GitMergeIcon,
  GitPullRequestIcon,
  GitPullRequestArrowIcon,
  GitPullRequestClosedIcon,
  GitPullRequestCreateIcon,
  GitPullRequestCreateArrowIcon,
  GitPullRequestDraftIcon,
  GithubIcon,
  GitlabIcon,
  GlassWaterIcon,
  GlassesIcon,
  GlobeIcon,
  GlobeLockIcon,
  GoalIcon,
  GrabIcon,
  GraduationCapIcon,
  GrapeIcon,
  Grid2X2Icon,
  Grid2x2CheckIcon,
  Grid2x2XIcon,
  Grid3X3Icon,
  GripIcon,
  GripHorizontalIcon,
  GripVerticalIcon,
  GroupIcon,
  GuitarIcon,
  HamIcon,
  HammerIcon,
  HandIcon,
  HandCoinsIcon,
  HandHeartIcon,
  HandHelpingIcon,
  HandMetalIcon,
  HandPlatterIcon,
  HandshakeIcon,
  HardDriveIcon,
  HardDriveDownloadIcon,
  HardDriveUploadIcon,
  HardHatIcon,
  HashIcon,
  HazeIcon,
  HdmiPortIcon,
  HeadingIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  HeadphonesIcon,
  HeadsetIcon,
  HeartIcon,
  HeartCrackIcon,
  HeartHandshakeIcon,
  HeartOffIcon,
  HeartPulseIcon,
  HeaterIcon,
  HexagonIcon,
  HighlighterIcon,
  HistoryIcon,
  HomeIcon,
  HopIcon,
  HopOffIcon,
  HospitalIcon,
  HotelIcon,
  HourglassIcon,
  IceCream2Icon,
  IceCreamConeIcon,
  ImageIcon,
  ImageDownIcon,
  ImageMinusIcon,
  ImageOffIcon,
  ImagePlayIcon,
  ImagePlusIcon,
  ImageUpIcon,
  ImagesIcon,
  ImportIcon,
  InboxIcon,
  IndentDecreaseIcon,
  IndentIcon,
  IndianRupeeIcon,
  InfinityIcon,
  InfoIcon,
  InspectionPanelIcon,
  InstagramIcon,
  ItalicIcon,
  IterationCcwIcon,
  IterationCwIcon,
  JapaneseYenIcon,
  JoystickIcon,
  KanbanIcon,
  KeyIcon,
  KeyRoundIcon,
  KeySquareIcon,
  KeyboardIcon,
  KeyboardMusicIcon,
  KeyboardOffIcon,
  LampIcon,
  LampCeilingIcon,
  LampDeskIcon,
  LampFloorIcon,
  LampWallDownIcon,
  LampWallUpIcon,
  LandPlotIcon,
  LandmarkIcon,
  LanguagesIcon,
  LaptopIcon,
  Laptop2Icon,
  LassoIcon,
  LassoSelectIcon,
  LaughIcon,
  LayersIcon,
  Layers2Icon,
  Layers3Icon,
  LayoutDashboardIcon,
  LayoutGridIcon,
  LayoutListIcon,
  LayoutPanelLeftIcon,
  LayoutPanelTopIcon,
  LayoutTemplateIcon,
  LeafIcon,
  LeafyGreenIcon,
  LibraryIcon,
  LibraryBigIcon,
  LifeBuoyIcon,
  LigatureIcon,
  LightbulbIcon,
  LightbulbOffIcon,
  LineChartIcon,
  LinkIcon,
  Link2Icon,
  Link2OffIcon,
  LinkedinIcon,
  ListIcon,
  ListChecksIcon,
  ListCollapseIcon,
  ListEndIcon,
  ListFilterIcon,
  ListMinusIcon,
  ListMusicIcon,
  ListOrderedIcon,
  ListPlusIcon,
  ListRestartIcon,
  ListStartIcon,
  ListTodoIcon,
  ListTreeIcon,
  ListVideoIcon,
  ListXIcon,
  LoaderIcon,
  Loader2Icon,
  LoaderPinwheelIcon,
  LocateIcon,
  LocateFixedIcon,
  LocateOffIcon,
  LockIcon,
  LockKeyholeIcon,
  LockKeyholeOpenIcon,
  LockOpenIcon,
  LogInIcon,
  LogOutIcon,
  LollipopIcon,
  LuggageIcon,
  MagnetIcon,
  MailIcon,
  MailCheckIcon,
  MailMinusIcon,
  MailOpenIcon,
  MailPlusIcon,
  MailQuestionIcon,
  MailSearchIcon,
  MailWarningIcon,
  MailXIcon,
  MailboxIcon,
  MailsIcon,
  MapIcon,
  MapPinIcon,
  MapPinOffIcon,
  MapPinnedIcon,
  MartiniIcon,
  MaximizeIcon,
  Maximize2Icon,
  MedalIcon,
  MegaphoneIcon,
  MegaphoneOffIcon,
  MehIcon,
  MemoryStickIcon,
  MenuIcon,
  MergeIcon,
  MessageCircleIcon,
  MessageCircleCodeIcon,
  MessageCircleDashedIcon,
  MessageCircleHeartIcon,
  MessageCircleMoreIcon,
  MessageCircleOffIcon,
  MessageCirclePlusIcon,
  MessageCircleQuestionIcon,
  MessageCircleReplyIcon,
  MessageCircleWarningIcon,
  MessageCircleXIcon,
  MessageSquareIcon,
  MessageSquareCodeIcon,
  MessageSquareDashedIcon,
  MessageSquareDiffIcon,
  MessageSquareDotIcon,
  MessageSquareHeartIcon,
  MessageSquareMoreIcon,
  MessageSquareOffIcon,
  MessageSquarePlusIcon,
  MessageSquareQuoteIcon,
  MessageSquareReplyIcon,
  MessageSquareShareIcon,
  MessageSquareTextIcon,
  MessageSquareWarningIcon,
  MessageSquareXIcon,
  MessagesSquareIcon,
  MicIcon,
  MicOffIcon,
  Mic2Icon,
  MicroscopeIcon,
  MicrowaveIcon,
  MilestoneIcon,
  MilkIcon,
  MilkOffIcon,
  MinimizeIcon,
  Minimize2Icon,
  MinusIcon,
  MonitorIcon,
  MonitorCheckIcon,
  MonitorDotIcon,
  MonitorDownIcon,
  MonitorOffIcon,
  MonitorPauseIcon,
  MonitorPlayIcon,
  MonitorSmartphoneIcon,
  MonitorSpeakerIcon,
  MonitorStopIcon,
  MonitorUpIcon,
  MonitorXIcon,
  MoonIcon,
  MoonStarIcon,
  MountainIcon,
  MountainSnowIcon,
  MouseIcon,
  MouseOffIcon,
  MousePointerIcon,
  MousePointer2Icon,
  MousePointerBanIcon,
  MousePointerClickIcon,
  MoveIcon,
  Move3DIcon,
  MoveDiagonalIcon,
  MoveDiagonal2Icon,
  MoveDownIcon,
  MoveDownLeftIcon,
  MoveDownRightIcon,
  MoveHorizontalIcon,
  MoveLeftIcon,
  MoveRightIcon,
  MoveUpIcon,
  MoveUpLeftIcon,
  MoveUpRightIcon,
  MoveVerticalIcon,
  MusicIcon,
  Music2Icon,
  Music3Icon,
  Music4Icon,
  NavigationIcon,
  Navigation2Icon,
  Navigation2OffIcon,
  NavigationOffIcon,
  NetworkIcon,
  NewspaperIcon,
  NfcIcon,
  NotebookIcon,
  NotebookPenIcon,
  NotebookTabsIcon,
  NotebookTextIcon,
  NotepadTextIcon,
  NotepadTextDashedIcon,
  NutIcon,
  NutOffIcon,
  OctagonIcon,
  AlertOctagonIcon,
  OctagonPauseIcon,
  OctagonXIcon,
  OptionIcon,
  OrbitIcon,
  OrigamiIcon,
  PackageIcon,
  Package2Icon,
  PackageCheckIcon,
  PackageMinusIcon,
  PackageOpenIcon,
  PackagePlusIcon,
  PackageSearchIcon,
  PackageXIcon,
  PaintBucketIcon,
  PaintRollerIcon,
  PaintbrushIcon,
  Paintbrush2Icon,
  PaletteIcon,
  PanelBottomIcon,
  PanelBottomCloseIcon,
  PanelBottomDashedIcon,
  PanelBottomOpenIcon,
  PanelLeftIcon,
  PanelLeftCloseIcon,
  PanelLeftDashedIcon,
  PanelLeftOpenIcon,
  PanelRightIcon,
  PanelRightCloseIcon,
  PanelRightDashedIcon,
  PanelRightOpenIcon,
  PanelTopIcon,
  PanelTopCloseIcon,
  PanelTopDashedIcon,
  PanelTopOpenIcon,
  PanelsLeftBottomIcon,
  PanelsRightBottomIcon,
  LayoutIcon,
  PaperclipIcon,
  ParenthesesIcon,
  ParkingMeterIcon,
  PartyPopperIcon,
  PauseIcon,
  PawPrintIcon,
  PcCaseIcon,
  Edit2Icon,
  Edit3Icon,
  PenToolIcon,
  PencilIcon,
  PencilLineIcon,
  PencilRulerIcon,
  PentagonIcon,
  PercentIcon,
  PersonStandingIcon,
  PhoneIcon,
  PhoneCallIcon,
  PhoneForwardedIcon,
  PhoneIncomingIcon,
  PhoneMissedIcon,
  PhoneOffIcon,
  PhoneOutgoingIcon,
  PiIcon,
  PianoIcon,
  PickaxeIcon,
  PictureInPictureIcon,
  PictureInPicture2Icon,
  PieChartIcon,
  PiggyBankIcon,
  PilcrowIcon,
  PilcrowLeftIcon,
  PilcrowRightIcon,
  PillIcon,
  PinIcon,
  PinOffIcon,
  PipetteIcon,
  PizzaIcon,
  PlaneIcon,
  PlaneLandingIcon,
  PlaneTakeoffIcon,
  PlayIcon,
  PlugIcon,
  Plug2Icon,
  PlugZapIcon,
  PlugZap2Icon,
  PlusIcon,
  PocketIcon,
  PocketKnifeIcon,
  PodcastIcon,
  PointerIcon,
  PointerOffIcon,
  PopcornIcon,
  PopsicleIcon,
  PoundSterlingIcon,
  PowerIcon,
  PowerOffIcon,
  PresentationIcon,
  PrinterIcon,
  ProjectorIcon,
  ProportionsIcon,
  PuzzleIcon,
  PyramidIcon,
  QrCodeIcon,
  QuoteIcon,
  RabbitIcon,
  RadarIcon,
  RadiationIcon,
  RadicalIcon,
  RadioIcon,
  RadioReceiverIcon,
  RadioTowerIcon,
  RadiusIcon,
  RailSymbolIcon,
  RainbowIcon,
  RatIcon,
  RatioIcon,
  ReceiptIcon,
  ReceiptCentIcon,
  ReceiptEuroIcon,
  ReceiptIndianRupeeIcon,
  ReceiptJapaneseYenIcon,
  ReceiptPoundSterlingIcon,
  ReceiptRussianRubleIcon,
  ReceiptSwissFrancIcon,
  ReceiptTextIcon,
  FormInputIcon,
  RectangleHorizontalIcon,
  RectangleVerticalIcon,
  RecycleIcon,
  RedoIcon,
  Redo2Icon,
  RedoDotIcon,
  RefreshCcwIcon,
  RefreshCcwDotIcon,
  RefreshCwIcon,
  RefreshCwOffIcon,
  RefrigeratorIcon,
  RegexIcon,
  RemoveFormattingIcon,
  RepeatIcon,
  Repeat1Icon,
  Repeat2Icon,
  ReplaceIcon,
  ReplaceAllIcon,
  ReplyIcon,
  ReplyAllIcon,
  RewindIcon,
  RibbonIcon,
  RocketIcon,
  RockingChairIcon,
  RollerCoasterIcon,
  Rotate3DIcon,
  RotateCcwIcon,
  RotateCcwSquareIcon,
  RotateCwIcon,
  RotateCwSquareIcon,
  RouteIcon,
  RouteOffIcon,
  RouterIcon,
  Rows2Icon,
  PanelsTopBottomIcon,
  Rows4Icon,
  RssIcon,
  RulerIcon,
  RussianRubleIcon,
  SailboatIcon,
  SaladIcon,
  SandwichIcon,
  SatelliteIcon,
  SatelliteDishIcon,
  SaveIcon,
  SaveAllIcon,
  ScaleIcon,
  Scale3DIcon,
  ScalingIcon,
  ScanIcon,
  ScanBarcodeIcon,
  ScanEyeIcon,
  ScanFaceIcon,
  ScanLineIcon,
  ScanSearchIcon,
  ScanTextIcon,
  ScatterChartIcon,
  SchoolIcon,
  ScissorsIcon,
  ScissorsLineDashedIcon,
  ScreenShareIcon,
  ScreenShareOffIcon,
  ScrollIcon,
  ScrollTextIcon,
  SearchIcon,
  SearchCheckIcon,
  SearchCodeIcon,
  SearchSlashIcon,
  SearchXIcon,
  SendIcon,
  SendHorizonalIcon,
  SendToBackIcon,
  SeparatorHorizontalIcon,
  SeparatorVerticalIcon,
  ServerIcon,
  ServerCogIcon,
  ServerCrashIcon,
  ServerOffIcon,
  SettingsIcon,
  Settings2Icon,
  ShapesIcon,
  ShareIcon,
  Share2Icon,
  SheetIcon,
  ShellIcon,
  ShieldIcon,
  ShieldAlertIcon,
  ShieldBanIcon,
  ShieldCheckIcon,
  ShieldEllipsisIcon,
  ShieldHalfIcon,
  ShieldMinusIcon,
  ShieldOffIcon,
  ShieldPlusIcon,
  ShieldQuestionIcon,
  ShieldCloseIcon,
  ShipIcon,
  ShipWheelIcon,
  ShirtIcon,
  ShoppingBagIcon,
  ShoppingBasketIcon,
  ShoppingCartIcon,
  ShovelIcon,
  ShowerHeadIcon,
  ShrinkIcon,
  ShrubIcon,
  ShuffleIcon,
  SigmaIcon,
  SignalIcon,
  SignalHighIcon,
  SignalLowIcon,
  SignalMediumIcon,
  SignalZeroIcon,
  SignpostIcon,
  SignpostBigIcon,
  SirenIcon,
  SkipBackIcon,
  SkipForwardIcon,
  SkullIcon,
  SlackIcon,
  SlashIcon,
  SliceIcon,
  SlidersHorizontalIcon,
  SlidersIcon,
  SmartphoneIcon,
  SmartphoneChargingIcon,
  SmartphoneNfcIcon,
  SmileIcon,
  SmilePlusIcon,
  SnailIcon,
  SnowflakeIcon,
  SofaIcon,
  SoupIcon,
  SpaceIcon,
  SpadeIcon,
  SparkleIcon,
  SparklesIcon,
  SpeakerIcon,
  SpeechIcon,
  SpellCheckIcon,
  SpellCheck2Icon,
  SplineIcon,
  SplitIcon,
  SprayCanIcon,
  SproutIcon,
  SquareIcon,
  ActivitySquareIcon,
  ArrowDownSquareIcon,
  ArrowDownLeftSquareIcon,
  ArrowDownRightSquareIcon,
  ArrowLeftSquareIcon,
  ArrowDownLeftFromSquareIcon,
  ArrowDownRightFromSquareIcon,
  ArrowUpLeftFromSquareIcon,
  ArrowUpRightFromSquareIcon,
  ArrowRightSquareIcon,
  ArrowUpSquareIcon,
  ArrowUpLeftSquareIcon,
  ArrowUpRightSquareIcon,
  AsteriskSquareIcon,
  ScissorsSquareDashedBottomIcon,
  CheckSquare2Icon,
  CheckSquareIcon,
  ChevronDownSquareIcon,
  ChevronLeftSquareIcon,
  ChevronRightSquareIcon,
  ChevronUpSquareIcon,
  CodeSquareIcon,
  SquareDashedBottomIcon,
  SquareDashedBottomCodeIcon,
  KanbanSquareDashedIcon,
  MousePointerSquareDashedIcon,
  DivideSquareIcon,
  DotSquareIcon,
  EqualSquareIcon,
  FunctionSquareIcon,
  GanttChartSquareIcon,
  KanbanSquareIcon,
  LibrarySquareIcon,
  MSquareIcon,
  MenuSquareIcon,
  MinusSquareIcon,
  InspectIcon,
  ParkingSquareIcon,
  ParkingSquareOffIcon,
  EditIcon,
  PercentSquareIcon,
  PiSquareIcon,
  PilcrowSquareIcon,
  PlaySquareIcon,
  PlusSquareIcon,
  PowerSquareIcon,
  SquareRadicalIcon,
  ScissorsSquareIcon,
  SigmaSquareIcon,
  SlashSquareIcon,
  SplitSquareHorizontalIcon,
  SplitSquareVerticalIcon,
  SquareStackIcon,
  SquareTerminalIcon,
  SquareUserIcon,
  SquareUserRoundIcon,
  SquareXIcon,
  SquircleIcon,
  SquirrelIcon,
  StampIcon,
  StarIcon,
  StarHalfIcon,
  StarOffIcon,
  StepBackIcon,
  StepForwardIcon,
  StethoscopeIcon,
  StickerIcon,
  StickyNoteIcon,
  StoreIcon,
  StretchHorizontalIcon,
  StretchVerticalIcon,
  StrikethroughIcon,
  SubscriptIcon,
  SunIcon,
  SunDimIcon,
  SunMediumIcon,
  SunMoonIcon,
  SunSnowIcon,
  SunriseIcon,
  SunsetIcon,
  SuperscriptIcon,
  SwatchBookIcon,
  SwissFrancIcon,
  SwitchCameraIcon,
  SwordIcon,
  SwordsIcon,
  SyringeIcon,
  TableIcon,
  Table2Icon,
  TableCellsMergeIcon,
  TableCellsSplitIcon,
  TableColumnsSplitIcon,
  TablePropertiesIcon,
  TableRowsSplitIcon,
  TabletIcon,
  TabletSmartphoneIcon,
  TabletsIcon,
  TagIcon,
  TagsIcon,
  Tally1Icon,
  Tally2Icon,
  Tally3Icon,
  Tally4Icon,
  Tally5Icon,
  TangentIcon,
  TargetIcon,
  TelescopeIcon,
  TentIcon,
  TentTreeIcon,
  TerminalIcon,
  TestTubeIcon,
  TestTube2Icon,
  TestTubesIcon,
  TextIcon,
  TextCursorIcon,
  TextCursorInputIcon,
  TextQuoteIcon,
  TextSearchIcon,
  TextSelectIcon,
  TheaterIcon,
  ThermometerIcon,
  ThermometerSnowflakeIcon,
  ThermometerSunIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  TicketIcon,
  TicketCheckIcon,
  TicketMinusIcon,
  TicketPercentIcon,
  TicketPlusIcon,
  TicketSlashIcon,
  TicketXIcon,
  TimerIcon,
  TimerOffIcon,
  TimerResetIcon,
  ToggleLeftIcon,
  ToggleRightIcon,
  TornadoIcon,
  TorusIcon,
  TouchpadIcon,
  TouchpadOffIcon,
  TowerControlIcon,
  ToyBrickIcon,
  TractorIcon,
  TrafficConeIcon,
  TrainFrontIcon,
  TrainFrontTunnelIcon,
  TrainTrackIcon,
  TrainIcon,
  TrashIcon,
  Trash2Icon,
  TreeDeciduousIcon,
  PalmtreeIcon,
  TreePineIcon,
  TreesIcon,
  TrelloIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  TriangleIcon,
  AlertTriangleIcon,
  TriangleRightIcon,
  TrophyIcon,
  TruckIcon,
  TurtleIcon,
  TvIcon,
  Tv2Icon,
  TwitchIcon,
  TwitterIcon,
  TypeIcon,
  UmbrellaIcon,
  UmbrellaOffIcon,
  UnderlineIcon,
  UndoIcon,
  Undo2Icon,
  UndoDotIcon,
  UnfoldHorizontalIcon,
  UnfoldVerticalIcon,
  UngroupIcon,
  School2Icon,
  UnlinkIcon,
  Unlink2Icon,
  UnplugIcon,
  UploadIcon,
  UsbIcon,
  UserIcon,
  UserCheckIcon,
  UserCogIcon,
  UserMinusIcon,
  UserPlusIcon,
  User2Icon,
  UserCheck2Icon,
  UserCog2Icon,
  UserMinus2Icon,
  UserPlus2Icon,
  UserRoundSearchIcon,
  UserRoundXIcon,
  UserSearchIcon,
  UserXIcon,
  UsersIcon,
  Users2Icon,
  UtensilsIcon,
  UtensilsCrossedIcon,
  UtilityPoleIcon,
  VariableIcon,
  VaultIcon,
  VeganIcon,
  VenetianMaskIcon,
  VibrateIcon,
  VibrateOffIcon,
  VideoIcon,
  VideoOffIcon,
  VideotapeIcon,
  ViewIcon,
  VoicemailIcon,
  VolumeIcon,
  Volume1Icon,
  Volume2Icon,
  VolumeXIcon,
  VoteIcon,
  WalletIcon,
  WalletCardsIcon,
  Wallet2Icon,
  WallpaperIcon,
  WandIcon,
  Wand2Icon,
  WarehouseIcon,
  WashingMachineIcon,
  WatchIcon,
  WavesIcon,
  WaypointsIcon,
  WebcamIcon,
  WebhookIcon,
  WebhookOffIcon,
  WeightIcon,
  WheatIcon,
  WheatOffIcon,
  WholeWordIcon,
  WifiIcon,
  WifiOffIcon,
  WindIcon,
  WineIcon,
  WineOffIcon,
  WorkflowIcon,
  WormIcon,
  WrapTextIcon,
  WrenchIcon,
  XIcon,
  YoutubeIcon,
  ZapIcon,
  ZapOffIcon,
  ZoomInIcon,
  ZoomOutIcon,
} from 'lucide-react';
import { APP_ICON_KEYS, DEFAULT_APP_ICON, type AppIconKey } from '@dragonhq/protocol';

export { DEFAULT_APP_ICON };
export type { AppIconKey };

/**
 * Shared icon set for customers and pages. The keys are the single source of
 * truth in `@dragonhq/protocol`'s `APP_ICON_KEYS`; this file maps each key to
 * its lucide-react component. The key names and import identifiers are taken
 * directly from lucide-react's own export table — when a kebab name would
 * derive to an identifier that clashes with another icon, lucide picks one
 * and this map follows that canonical choice.
 *
 * The key is stored verbatim inside the encrypted customer/document payload.
 * The manual picker was removed in favour of Haiku-driven selection, so no UI
 * iterates all icons — the map is only consulted when rendering a specific
 * chosen key. Vite tree-shakes unused icons from the production bundle.
 */
export const APP_ICONS: Record<AppIconKey, LucideIcon> = {
  'a-arrow-down': AArrowDownIcon,
  'a-arrow-up': AArrowUpIcon,
  'a-large-small': ALargeSmallIcon,
  'accessibility': AccessibilityIcon,
  'activity': ActivityIcon,
  'air-vent': AirVentIcon,
  'airplay': AirplayIcon,
  'alarm-clock': AlarmClockIcon,
  'alarm-clock-check': AlarmCheckIcon,
  'alarm-clock-minus': AlarmClockMinusIcon,
  'alarm-clock-off': AlarmClockOffIcon,
  'alarm-clock-plus': AlarmClockPlusIcon,
  'alarm-smoke': AlarmSmokeIcon,
  'album': AlbumIcon,
  'align-center': AlignCenterIcon,
  'align-center-horizontal': AlignCenterHorizontalIcon,
  'align-center-vertical': AlignCenterVerticalIcon,
  'align-end-horizontal': AlignEndHorizontalIcon,
  'align-end-vertical': AlignEndVerticalIcon,
  'align-horizontal-distribute-center': AlignHorizontalDistributeCenterIcon,
  'align-horizontal-distribute-end': AlignHorizontalDistributeEndIcon,
  'align-horizontal-distribute-start': AlignHorizontalDistributeStartIcon,
  'align-horizontal-justify-center': AlignHorizontalJustifyCenterIcon,
  'align-horizontal-justify-end': AlignHorizontalJustifyEndIcon,
  'align-horizontal-justify-start': AlignHorizontalJustifyStartIcon,
  'align-horizontal-space-around': AlignHorizontalSpaceAroundIcon,
  'align-horizontal-space-between': AlignHorizontalSpaceBetweenIcon,
  'align-justify': AlignJustifyIcon,
  'align-left': AlignLeftIcon,
  'align-right': AlignRightIcon,
  'align-start-horizontal': AlignStartHorizontalIcon,
  'align-start-vertical': AlignStartVerticalIcon,
  'align-vertical-distribute-center': AlignVerticalDistributeCenterIcon,
  'align-vertical-distribute-end': AlignVerticalDistributeEndIcon,
  'align-vertical-distribute-start': AlignVerticalDistributeStartIcon,
  'align-vertical-justify-center': AlignVerticalJustifyCenterIcon,
  'align-vertical-justify-end': AlignVerticalJustifyEndIcon,
  'align-vertical-justify-start': AlignVerticalJustifyStartIcon,
  'align-vertical-space-around': AlignVerticalSpaceAroundIcon,
  'align-vertical-space-between': AlignVerticalSpaceBetweenIcon,
  'ambulance': AmbulanceIcon,
  'ampersand': AmpersandIcon,
  'ampersands': AmpersandsIcon,
  'anchor': AnchorIcon,
  'angry': AngryIcon,
  'annoyed': AnnoyedIcon,
  'antenna': AntennaIcon,
  'anvil': AnvilIcon,
  'aperture': ApertureIcon,
  'app-window': AppWindowIcon,
  'app-window-mac': AppWindowMacIcon,
  'apple': AppleIcon,
  'archive': ArchiveIcon,
  'archive-restore': ArchiveRestoreIcon,
  'archive-x': ArchiveXIcon,
  'area-chart': AreaChartIcon,
  'armchair': ArmchairIcon,
  'arrow-big-down': ArrowBigDownIcon,
  'arrow-big-down-dash': ArrowBigDownDashIcon,
  'arrow-big-left': ArrowBigLeftIcon,
  'arrow-big-left-dash': ArrowBigLeftDashIcon,
  'arrow-big-right': ArrowBigRightIcon,
  'arrow-big-right-dash': ArrowBigRightDashIcon,
  'arrow-big-up': ArrowBigUpIcon,
  'arrow-big-up-dash': ArrowBigUpDashIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-down-0-1': ArrowDown01Icon,
  'arrow-down-1-0': ArrowDown10Icon,
  'arrow-down-a-z': ArrowDownAZIcon,
  'arrow-down-from-line': ArrowDownFromLineIcon,
  'arrow-down-left': ArrowDownLeftIcon,
  'arrow-down-narrow-wide': ArrowDownNarrowWideIcon,
  'arrow-down-right': ArrowDownRightIcon,
  'arrow-down-to-dot': ArrowDownToDotIcon,
  'arrow-down-to-line': ArrowDownToLineIcon,
  'arrow-down-up': ArrowDownUpIcon,
  'arrow-down-wide-narrow': ArrowDownWideNarrowIcon,
  'arrow-down-z-a': ArrowDownZAIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-left-from-line': ArrowLeftFromLineIcon,
  'arrow-left-right': ArrowLeftRightIcon,
  'arrow-left-to-line': ArrowLeftToLineIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-right-from-line': ArrowRightFromLineIcon,
  'arrow-right-left': ArrowRightLeftIcon,
  'arrow-right-to-line': ArrowRightToLineIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-up-0-1': ArrowUp01Icon,
  'arrow-up-1-0': ArrowUp10Icon,
  'arrow-up-a-z': ArrowUpAZIcon,
  'arrow-up-down': ArrowUpDownIcon,
  'arrow-up-from-dot': ArrowUpFromDotIcon,
  'arrow-up-from-line': ArrowUpFromLineIcon,
  'arrow-up-left': ArrowUpLeftIcon,
  'arrow-up-narrow-wide': ArrowUpNarrowWideIcon,
  'arrow-up-right': ArrowUpRightIcon,
  'arrow-up-to-line': ArrowUpToLineIcon,
  'arrow-up-wide-narrow': ArrowUpWideNarrowIcon,
  'arrow-up-z-a': ArrowUpZAIcon,
  'arrows-up-from-line': ArrowsUpFromLineIcon,
  'asterisk': AsteriskIcon,
  'at-sign': AtSignIcon,
  'atom': AtomIcon,
  'audio-lines': AudioLinesIcon,
  'audio-waveform': AudioWaveformIcon,
  'award': AwardIcon,
  'axe': AxeIcon,
  'axis-3d': Axis3DIcon,
  'baby': BabyIcon,
  'backpack': BackpackIcon,
  'badge': BadgeIcon,
  'badge-alert': BadgeAlertIcon,
  'badge-cent': BadgeCentIcon,
  'badge-check': BadgeCheckIcon,
  'badge-dollar-sign': BadgeDollarSignIcon,
  'badge-euro': BadgeEuroIcon,
  'badge-help': BadgeHelpIcon,
  'badge-indian-rupee': BadgeIndianRupeeIcon,
  'badge-info': BadgeInfoIcon,
  'badge-japanese-yen': BadgeJapaneseYenIcon,
  'badge-minus': BadgeMinusIcon,
  'badge-percent': BadgePercentIcon,
  'badge-plus': BadgePlusIcon,
  'badge-pound-sterling': BadgePoundSterlingIcon,
  'badge-russian-ruble': BadgeRussianRubleIcon,
  'badge-swiss-franc': BadgeSwissFrancIcon,
  'badge-x': BadgeXIcon,
  'baggage-claim': BaggageClaimIcon,
  'ban': BanIcon,
  'banana': BananaIcon,
  'banknote': BanknoteIcon,
  'bar-chart': BarChartIcon,
  'bar-chart-2': BarChart2Icon,
  'bar-chart-3': BarChart3Icon,
  'bar-chart-4': BarChart4Icon,
  'bar-chart-big': BarChartBigIcon,
  'bar-chart-horizontal': BarChartHorizontalIcon,
  'bar-chart-horizontal-big': BarChartHorizontalBigIcon,
  'barcode': BarcodeIcon,
  'baseline': BaselineIcon,
  'bath': BathIcon,
  'battery': BatteryIcon,
  'battery-charging': BatteryChargingIcon,
  'battery-full': BatteryFullIcon,
  'battery-low': BatteryLowIcon,
  'battery-medium': BatteryMediumIcon,
  'battery-warning': BatteryWarningIcon,
  'beaker': BeakerIcon,
  'bean': BeanIcon,
  'bean-off': BeanOffIcon,
  'bed': BedIcon,
  'bed-double': BedDoubleIcon,
  'bed-single': BedSingleIcon,
  'beef': BeefIcon,
  'beer': BeerIcon,
  'beer-off': BeerOffIcon,
  'bell': BellIcon,
  'bell-dot': BellDotIcon,
  'bell-electric': BellElectricIcon,
  'bell-minus': BellMinusIcon,
  'bell-off': BellOffIcon,
  'bell-plus': BellPlusIcon,
  'bell-ring': BellRingIcon,
  'between-horizontal-end': BetweenHorizonalEndIcon,
  'between-horizontal-start': BetweenHorizonalStartIcon,
  'between-vertical-end': BetweenVerticalEndIcon,
  'between-vertical-start': BetweenVerticalStartIcon,
  'bike': BikeIcon,
  'binary': BinaryIcon,
  'biohazard': BiohazardIcon,
  'bird': BirdIcon,
  'bitcoin': BitcoinIcon,
  'blend': BlendIcon,
  'blinds': BlindsIcon,
  'blocks': BlocksIcon,
  'bluetooth': BluetoothIcon,
  'bluetooth-connected': BluetoothConnectedIcon,
  'bluetooth-off': BluetoothOffIcon,
  'bluetooth-searching': BluetoothSearchingIcon,
  'bold': BoldIcon,
  'bolt': BoltIcon,
  'bomb': BombIcon,
  'bone': BoneIcon,
  'book': BookIcon,
  'book-a': BookAIcon,
  'book-audio': BookAudioIcon,
  'book-check': BookCheckIcon,
  'book-copy': BookCopyIcon,
  'book-dashed': BookDashedIcon,
  'book-down': BookDownIcon,
  'book-headphones': BookHeadphonesIcon,
  'book-heart': BookHeartIcon,
  'book-image': BookImageIcon,
  'book-key': BookKeyIcon,
  'book-lock': BookLockIcon,
  'book-marked': BookMarkedIcon,
  'book-minus': BookMinusIcon,
  'book-open': BookOpenIcon,
  'book-open-check': BookOpenCheckIcon,
  'book-open-text': BookOpenTextIcon,
  'book-plus': BookPlusIcon,
  'book-text': BookTextIcon,
  'book-type': BookTypeIcon,
  'book-up': BookUpIcon,
  'book-up-2': BookUp2Icon,
  'book-user': BookUserIcon,
  'book-x': BookXIcon,
  'bookmark': BookmarkIcon,
  'bookmark-check': BookmarkCheckIcon,
  'bookmark-minus': BookmarkMinusIcon,
  'bookmark-plus': BookmarkPlusIcon,
  'bookmark-x': BookmarkXIcon,
  'boom-box': BoomBoxIcon,
  'bot': BotIcon,
  'bot-message-square': BotMessageSquareIcon,
  'bot-off': BotOffIcon,
  'box': BoxIcon,
  'box-select': BoxSelectIcon,
  'boxes': BoxesIcon,
  'braces': BracesIcon,
  'brackets': BracketsIcon,
  'brain': BrainIcon,
  'brain-circuit': BrainCircuitIcon,
  'brain-cog': BrainCogIcon,
  'brick-wall': BrickWallIcon,
  'briefcase': BriefcaseIcon,
  'briefcase-business': BriefcaseBusinessIcon,
  'briefcase-medical': BriefcaseMedicalIcon,
  'bring-to-front': BringToFrontIcon,
  'brush': BrushIcon,
  'bug': BugIcon,
  'bug-off': BugOffIcon,
  'bug-play': BugPlayIcon,
  'building': BuildingIcon,
  'building-2': Building2Icon,
  'bus': BusIcon,
  'bus-front': BusFrontIcon,
  'cable': CableIcon,
  'cable-car': CableCarIcon,
  'cake': CakeIcon,
  'cake-slice': CakeSliceIcon,
  'calculator': CalculatorIcon,
  'calendar': CalendarIcon,
  'calendar-check': CalendarCheckIcon,
  'calendar-check-2': CalendarCheck2Icon,
  'calendar-clock': CalendarClockIcon,
  'calendar-days': CalendarDaysIcon,
  'calendar-fold': CalendarFoldIcon,
  'calendar-heart': CalendarHeartIcon,
  'calendar-minus': CalendarMinusIcon,
  'calendar-minus-2': CalendarMinus2Icon,
  'calendar-off': CalendarOffIcon,
  'calendar-plus': CalendarPlusIcon,
  'calendar-plus-2': CalendarPlus2Icon,
  'calendar-range': CalendarRangeIcon,
  'calendar-search': CalendarSearchIcon,
  'calendar-x': CalendarXIcon,
  'calendar-x-2': CalendarX2Icon,
  'camera': CameraIcon,
  'camera-off': CameraOffIcon,
  'candlestick-chart': CandlestickChartIcon,
  'candy': CandyIcon,
  'candy-cane': CandyCaneIcon,
  'candy-off': CandyOffIcon,
  'cannabis': CannabisIcon,
  'captions': CaptionsIcon,
  'captions-off': CaptionsOffIcon,
  'car': CarIcon,
  'car-front': CarFrontIcon,
  'car-taxi-front': CarTaxiFrontIcon,
  'caravan': CaravanIcon,
  'carrot': CarrotIcon,
  'case-lower': CaseLowerIcon,
  'case-sensitive': CaseSensitiveIcon,
  'case-upper': CaseUpperIcon,
  'cassette-tape': CassetteTapeIcon,
  'cast': CastIcon,
  'castle': CastleIcon,
  'cat': CatIcon,
  'cctv': CctvIcon,
  'check': CheckIcon,
  'check-check': CheckCheckIcon,
  'chef-hat': ChefHatIcon,
  'cherry': CherryIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-first': ChevronFirstIcon,
  'chevron-last': ChevronLastIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-up': ChevronUpIcon,
  'chevrons-down': ChevronsDownIcon,
  'chevrons-down-up': ChevronsDownUpIcon,
  'chevrons-left': ChevronsLeftIcon,
  'chevrons-left-right': ChevronsLeftRightIcon,
  'chevrons-right': ChevronsRightIcon,
  'chevrons-right-left': ChevronsRightLeftIcon,
  'chevrons-up': ChevronsUpIcon,
  'chevrons-up-down': ChevronsUpDownIcon,
  'chrome': ChromeIcon,
  'church': ChurchIcon,
  'cigarette': CigaretteIcon,
  'cigarette-off': CigaretteOffIcon,
  'circle': CircleIcon,
  'circle-alert': AlertCircleIcon,
  'circle-arrow-down': ArrowDownCircleIcon,
  'circle-arrow-left': ArrowLeftCircleIcon,
  'circle-arrow-out-down-left': ArrowDownLeftFromCircleIcon,
  'circle-arrow-out-down-right': ArrowDownRightFromCircleIcon,
  'circle-arrow-out-up-left': ArrowUpLeftFromCircleIcon,
  'circle-arrow-out-up-right': ArrowUpRightFromCircleIcon,
  'circle-arrow-right': ArrowRightCircleIcon,
  'circle-arrow-up': ArrowUpCircleIcon,
  'circle-check': CheckCircle2Icon,
  'circle-check-big': CheckCircleIcon,
  'circle-chevron-down': ChevronDownCircleIcon,
  'circle-chevron-left': ChevronLeftCircleIcon,
  'circle-chevron-right': ChevronRightCircleIcon,
  'circle-chevron-up': ChevronUpCircleIcon,
  'circle-dashed': CircleDashedIcon,
  'circle-divide': CircleDivideIcon,
  'circle-dollar-sign': CircleDollarSignIcon,
  'circle-dot': CircleDotIcon,
  'circle-dot-dashed': CircleDotDashedIcon,
  'circle-ellipsis': CircleEllipsisIcon,
  'circle-equal': CircleEqualIcon,
  'circle-fading-plus': CircleFadingPlusIcon,
  'circle-gauge': CircleGaugeIcon,
  'circle-help': CircleHelpIcon,
  'circle-minus': CircleMinusIcon,
  'circle-off': CircleOffIcon,
  'circle-parking': CircleParkingIcon,
  'circle-parking-off': CircleParkingOffIcon,
  'circle-pause': CirclePauseIcon,
  'circle-percent': CirclePercentIcon,
  'circle-play': CirclePlayIcon,
  'circle-plus': CirclePlusIcon,
  'circle-power': CirclePowerIcon,
  'circle-slash': CircleSlashIcon,
  'circle-slash-2': CircleSlash2Icon,
  'circle-stop': CircleStopIcon,
  'circle-user': CircleUserIcon,
  'circle-user-round': CircleUserRoundIcon,
  'circle-x': CircleXIcon,
  'circuit-board': CircuitBoardIcon,
  'citrus': CitrusIcon,
  'clapperboard': ClapperboardIcon,
  'clipboard': ClipboardIcon,
  'clipboard-check': ClipboardCheckIcon,
  'clipboard-copy': ClipboardCopyIcon,
  'clipboard-list': ClipboardListIcon,
  'clipboard-minus': ClipboardMinusIcon,
  'clipboard-paste': ClipboardPasteIcon,
  'clipboard-pen': ClipboardEditIcon,
  'clipboard-pen-line': ClipboardPenLineIcon,
  'clipboard-plus': ClipboardPlusIcon,
  'clipboard-type': ClipboardTypeIcon,
  'clipboard-x': ClipboardXIcon,
  'clock': ClockIcon,
  'clock-1': Clock1Icon,
  'clock-10': Clock10Icon,
  'clock-11': Clock11Icon,
  'clock-12': Clock12Icon,
  'clock-2': Clock2Icon,
  'clock-3': Clock3Icon,
  'clock-4': Clock4Icon,
  'clock-5': Clock5Icon,
  'clock-6': Clock6Icon,
  'clock-7': Clock7Icon,
  'clock-8': Clock8Icon,
  'clock-9': Clock9Icon,
  'cloud': CloudIcon,
  'cloud-cog': CloudCogIcon,
  'cloud-download': CloudDownloadIcon,
  'cloud-drizzle': CloudDrizzleIcon,
  'cloud-fog': CloudFogIcon,
  'cloud-hail': CloudHailIcon,
  'cloud-lightning': CloudLightningIcon,
  'cloud-moon': CloudMoonIcon,
  'cloud-moon-rain': CloudMoonRainIcon,
  'cloud-off': CloudOffIcon,
  'cloud-rain': CloudRainIcon,
  'cloud-rain-wind': CloudRainWindIcon,
  'cloud-snow': CloudSnowIcon,
  'cloud-sun': CloudSunIcon,
  'cloud-sun-rain': CloudSunRainIcon,
  'cloud-upload': CloudUploadIcon,
  'cloudy': CloudyIcon,
  'clover': CloverIcon,
  'club': ClubIcon,
  'code': CodeIcon,
  'code-xml': Code2Icon,
  'codepen': CodepenIcon,
  'codesandbox': CodesandboxIcon,
  'coffee': CoffeeIcon,
  'cog': CogIcon,
  'coins': CoinsIcon,
  'columns-2': Columns2Icon,
  'columns-3': Columns3Icon,
  'columns-4': Columns4Icon,
  'combine': CombineIcon,
  'command': CommandIcon,
  'compass': CompassIcon,
  'component': ComponentIcon,
  'computer': ComputerIcon,
  'concierge-bell': ConciergeBellIcon,
  'cone': ConeIcon,
  'construction': ConstructionIcon,
  'contact': ContactIcon,
  'contact-round': Contact2Icon,
  'container': ContainerIcon,
  'contrast': ContrastIcon,
  'cookie': CookieIcon,
  'cooking-pot': CookingPotIcon,
  'copy': CopyIcon,
  'copy-check': CopyCheckIcon,
  'copy-minus': CopyMinusIcon,
  'copy-plus': CopyPlusIcon,
  'copy-slash': CopySlashIcon,
  'copy-x': CopyXIcon,
  'copyleft': CopyleftIcon,
  'copyright': CopyrightIcon,
  'corner-down-left': CornerDownLeftIcon,
  'corner-down-right': CornerDownRightIcon,
  'corner-left-down': CornerLeftDownIcon,
  'corner-left-up': CornerLeftUpIcon,
  'corner-right-down': CornerRightDownIcon,
  'corner-right-up': CornerRightUpIcon,
  'corner-up-left': CornerUpLeftIcon,
  'corner-up-right': CornerUpRightIcon,
  'cpu': CpuIcon,
  'creative-commons': CreativeCommonsIcon,
  'credit-card': CreditCardIcon,
  'croissant': CroissantIcon,
  'crop': CropIcon,
  'cross': CrossIcon,
  'crosshair': CrosshairIcon,
  'crown': CrownIcon,
  'cuboid': CuboidIcon,
  'cup-soda': CupSodaIcon,
  'currency': CurrencyIcon,
  'cylinder': CylinderIcon,
  'database': DatabaseIcon,
  'database-backup': DatabaseBackupIcon,
  'database-zap': DatabaseZapIcon,
  'delete': DeleteIcon,
  'dessert': DessertIcon,
  'diameter': DiameterIcon,
  'diamond': DiamondIcon,
  'diamond-minus': DiamondMinusIcon,
  'diamond-percent': DiamondPercentIcon,
  'diamond-plus': DiamondPlusIcon,
  'dice-1': Dice1Icon,
  'dice-2': Dice2Icon,
  'dice-3': Dice3Icon,
  'dice-4': Dice4Icon,
  'dice-5': Dice5Icon,
  'dice-6': Dice6Icon,
  'dices': DicesIcon,
  'diff': DiffIcon,
  'disc': DiscIcon,
  'disc-2': Disc2Icon,
  'disc-3': Disc3Icon,
  'disc-album': DiscAlbumIcon,
  'divide': DivideIcon,
  'dna': DnaIcon,
  'dna-off': DnaOffIcon,
  'dock': DockIcon,
  'dog': DogIcon,
  'dollar-sign': DollarSignIcon,
  'donut': DonutIcon,
  'door-closed': DoorClosedIcon,
  'door-open': DoorOpenIcon,
  'dot': DotIcon,
  'download': DownloadIcon,
  'drafting-compass': DraftingCompassIcon,
  'drama': DramaIcon,
  'dribbble': DribbbleIcon,
  'drill': DrillIcon,
  'droplet': DropletIcon,
  'droplets': DropletsIcon,
  'drum': DrumIcon,
  'drumstick': DrumstickIcon,
  'dumbbell': DumbbellIcon,
  'ear': EarIcon,
  'ear-off': EarOffIcon,
  'earth': EarthIcon,
  'earth-lock': EarthLockIcon,
  'eclipse': EclipseIcon,
  'egg': EggIcon,
  'egg-fried': EggFriedIcon,
  'egg-off': EggOffIcon,
  'ellipsis': EllipsisIcon,
  'ellipsis-vertical': EllipsisVerticalIcon,
  'equal': EqualIcon,
  'equal-not': EqualNotIcon,
  'eraser': EraserIcon,
  'euro': EuroIcon,
  'expand': ExpandIcon,
  'external-link': ExternalLinkIcon,
  'eye': EyeIcon,
  'eye-off': EyeOffIcon,
  'facebook': FacebookIcon,
  'factory': FactoryIcon,
  'fan': FanIcon,
  'fast-forward': FastForwardIcon,
  'feather': FeatherIcon,
  'fence': FenceIcon,
  'ferris-wheel': FerrisWheelIcon,
  'figma': FigmaIcon,
  'file': FileIcon,
  'file-archive': FileArchiveIcon,
  'file-audio': FileAudioIcon,
  'file-audio-2': FileAudio2Icon,
  'file-axis-3d': FileAxis3DIcon,
  'file-badge': FileBadgeIcon,
  'file-badge-2': FileBadge2Icon,
  'file-bar-chart': FileBarChartIcon,
  'file-bar-chart-2': FileBarChart2Icon,
  'file-box': FileBoxIcon,
  'file-check': FileCheckIcon,
  'file-check-2': FileCheck2Icon,
  'file-clock': FileClockIcon,
  'file-code': FileCodeIcon,
  'file-code-2': FileCode2Icon,
  'file-cog': FileCog2Icon,
  'file-diff': FileDiffIcon,
  'file-digit': FileDigitIcon,
  'file-down': FileDownIcon,
  'file-heart': FileHeartIcon,
  'file-image': FileImageIcon,
  'file-input': FileInputIcon,
  'file-json': FileJsonIcon,
  'file-json-2': FileJson2Icon,
  'file-key': FileKeyIcon,
  'file-key-2': FileKey2Icon,
  'file-line-chart': FileLineChartIcon,
  'file-lock': FileLockIcon,
  'file-lock-2': FileLock2Icon,
  'file-minus': FileMinusIcon,
  'file-minus-2': FileMinus2Icon,
  'file-music': FileMusicIcon,
  'file-output': FileOutputIcon,
  'file-pen': FileEditIcon,
  'file-pen-line': FilePenLineIcon,
  'file-pie-chart': FilePieChartIcon,
  'file-plus': FilePlusIcon,
  'file-plus-2': FilePlus2Icon,
  'file-question': FileQuestionIcon,
  'file-scan': FileScanIcon,
  'file-search': FileSearchIcon,
  'file-search-2': FileSearch2Icon,
  'file-sliders': FileSlidersIcon,
  'file-spreadsheet': FileSpreadsheetIcon,
  'file-stack': FileStackIcon,
  'file-symlink': FileSymlinkIcon,
  'file-terminal': FileTerminalIcon,
  'file-text': FileTextIcon,
  'file-type': FileTypeIcon,
  'file-type-2': FileType2Icon,
  'file-up': FileUpIcon,
  'file-video': FileVideoIcon,
  'file-video-2': FileVideo2Icon,
  'file-volume': FileVolumeIcon,
  'file-volume-2': FileVolume2Icon,
  'file-warning': FileWarningIcon,
  'file-x': FileXIcon,
  'file-x-2': FileX2Icon,
  'files': FilesIcon,
  'film': FilmIcon,
  'filter': FilterIcon,
  'filter-x': FilterXIcon,
  'fingerprint': FingerprintIcon,
  'fire-extinguisher': FireExtinguisherIcon,
  'fish': FishIcon,
  'fish-off': FishOffIcon,
  'fish-symbol': FishSymbolIcon,
  'flag': FlagIcon,
  'flag-off': FlagOffIcon,
  'flag-triangle-left': FlagTriangleLeftIcon,
  'flag-triangle-right': FlagTriangleRightIcon,
  'flame': FlameIcon,
  'flame-kindling': FlameKindlingIcon,
  'flashlight': FlashlightIcon,
  'flashlight-off': FlashlightOffIcon,
  'flask-conical': FlaskConicalIcon,
  'flask-conical-off': FlaskConicalOffIcon,
  'flask-round': FlaskRoundIcon,
  'flip-horizontal': FlipHorizontalIcon,
  'flip-horizontal-2': FlipHorizontal2Icon,
  'flip-vertical': FlipVerticalIcon,
  'flip-vertical-2': FlipVertical2Icon,
  'flower': FlowerIcon,
  'flower-2': Flower2Icon,
  'focus': FocusIcon,
  'fold-horizontal': FoldHorizontalIcon,
  'fold-vertical': FoldVerticalIcon,
  'folder': FolderIcon,
  'folder-archive': FolderArchiveIcon,
  'folder-check': FolderCheckIcon,
  'folder-clock': FolderClockIcon,
  'folder-closed': FolderClosedIcon,
  'folder-cog': FolderCog2Icon,
  'folder-dot': FolderDotIcon,
  'folder-down': FolderDownIcon,
  'folder-git': FolderGitIcon,
  'folder-git-2': FolderGit2Icon,
  'folder-heart': FolderHeartIcon,
  'folder-input': FolderInputIcon,
  'folder-kanban': FolderKanbanIcon,
  'folder-key': FolderKeyIcon,
  'folder-lock': FolderLockIcon,
  'folder-minus': FolderMinusIcon,
  'folder-open': FolderOpenIcon,
  'folder-open-dot': FolderOpenDotIcon,
  'folder-output': FolderOutputIcon,
  'folder-pen': FolderEditIcon,
  'folder-plus': FolderPlusIcon,
  'folder-root': FolderRootIcon,
  'folder-search': FolderSearchIcon,
  'folder-search-2': FolderSearch2Icon,
  'folder-symlink': FolderSymlinkIcon,
  'folder-sync': FolderSyncIcon,
  'folder-tree': FolderTreeIcon,
  'folder-up': FolderUpIcon,
  'folder-x': FolderXIcon,
  'folders': FoldersIcon,
  'footprints': FootprintsIcon,
  'forklift': ForkliftIcon,
  'forward': ForwardIcon,
  'frame': FrameIcon,
  'framer': FramerIcon,
  'frown': FrownIcon,
  'fuel': FuelIcon,
  'fullscreen': FullscreenIcon,
  'gallery-horizontal': GalleryHorizontalIcon,
  'gallery-horizontal-end': GalleryHorizontalEndIcon,
  'gallery-thumbnails': GalleryThumbnailsIcon,
  'gallery-vertical': GalleryVerticalIcon,
  'gallery-vertical-end': GalleryVerticalEndIcon,
  'gamepad': GamepadIcon,
  'gamepad-2': Gamepad2Icon,
  'gantt-chart': GanttChartIcon,
  'gauge': GaugeIcon,
  'gavel': GavelIcon,
  'gem': GemIcon,
  'ghost': GhostIcon,
  'gift': GiftIcon,
  'git-branch': GitBranchIcon,
  'git-branch-plus': GitBranchPlusIcon,
  'git-commit-horizontal': GitCommitHorizontalIcon,
  'git-commit-vertical': GitCommitVerticalIcon,
  'git-compare': GitCompareIcon,
  'git-compare-arrows': GitCompareArrowsIcon,
  'git-fork': GitForkIcon,
  'git-graph': GitGraphIcon,
  'git-merge': GitMergeIcon,
  'git-pull-request': GitPullRequestIcon,
  'git-pull-request-arrow': GitPullRequestArrowIcon,
  'git-pull-request-closed': GitPullRequestClosedIcon,
  'git-pull-request-create': GitPullRequestCreateIcon,
  'git-pull-request-create-arrow': GitPullRequestCreateArrowIcon,
  'git-pull-request-draft': GitPullRequestDraftIcon,
  'github': GithubIcon,
  'gitlab': GitlabIcon,
  'glass-water': GlassWaterIcon,
  'glasses': GlassesIcon,
  'globe': GlobeIcon,
  'globe-lock': GlobeLockIcon,
  'goal': GoalIcon,
  'grab': GrabIcon,
  'graduation-cap': GraduationCapIcon,
  'grape': GrapeIcon,
  'grid-2x2': Grid2X2Icon,
  'grid-2x2-check': Grid2x2CheckIcon,
  'grid-2x2-x': Grid2x2XIcon,
  'grid-3x3': Grid3X3Icon,
  'grip': GripIcon,
  'grip-horizontal': GripHorizontalIcon,
  'grip-vertical': GripVerticalIcon,
  'group': GroupIcon,
  'guitar': GuitarIcon,
  'ham': HamIcon,
  'hammer': HammerIcon,
  'hand': HandIcon,
  'hand-coins': HandCoinsIcon,
  'hand-heart': HandHeartIcon,
  'hand-helping': HandHelpingIcon,
  'hand-metal': HandMetalIcon,
  'hand-platter': HandPlatterIcon,
  'handshake': HandshakeIcon,
  'hard-drive': HardDriveIcon,
  'hard-drive-download': HardDriveDownloadIcon,
  'hard-drive-upload': HardDriveUploadIcon,
  'hard-hat': HardHatIcon,
  'hash': HashIcon,
  'haze': HazeIcon,
  'hdmi-port': HdmiPortIcon,
  'heading': HeadingIcon,
  'heading-1': Heading1Icon,
  'heading-2': Heading2Icon,
  'heading-3': Heading3Icon,
  'heading-4': Heading4Icon,
  'heading-5': Heading5Icon,
  'heading-6': Heading6Icon,
  'headphones': HeadphonesIcon,
  'headset': HeadsetIcon,
  'heart': HeartIcon,
  'heart-crack': HeartCrackIcon,
  'heart-handshake': HeartHandshakeIcon,
  'heart-off': HeartOffIcon,
  'heart-pulse': HeartPulseIcon,
  'heater': HeaterIcon,
  'hexagon': HexagonIcon,
  'highlighter': HighlighterIcon,
  'history': HistoryIcon,
  'home': HomeIcon,
  'hop': HopIcon,
  'hop-off': HopOffIcon,
  'hospital': HospitalIcon,
  'hotel': HotelIcon,
  'hourglass': HourglassIcon,
  'ice-cream-bowl': IceCream2Icon,
  'ice-cream-cone': IceCreamConeIcon,
  'image': ImageIcon,
  'image-down': ImageDownIcon,
  'image-minus': ImageMinusIcon,
  'image-off': ImageOffIcon,
  'image-play': ImagePlayIcon,
  'image-plus': ImagePlusIcon,
  'image-up': ImageUpIcon,
  'images': ImagesIcon,
  'import': ImportIcon,
  'inbox': InboxIcon,
  'indent-decrease': IndentDecreaseIcon,
  'indent-increase': IndentIcon,
  'indian-rupee': IndianRupeeIcon,
  'infinity': InfinityIcon,
  'info': InfoIcon,
  'inspection-panel': InspectionPanelIcon,
  'instagram': InstagramIcon,
  'italic': ItalicIcon,
  'iteration-ccw': IterationCcwIcon,
  'iteration-cw': IterationCwIcon,
  'japanese-yen': JapaneseYenIcon,
  'joystick': JoystickIcon,
  'kanban': KanbanIcon,
  'key': KeyIcon,
  'key-round': KeyRoundIcon,
  'key-square': KeySquareIcon,
  'keyboard': KeyboardIcon,
  'keyboard-music': KeyboardMusicIcon,
  'keyboard-off': KeyboardOffIcon,
  'lamp': LampIcon,
  'lamp-ceiling': LampCeilingIcon,
  'lamp-desk': LampDeskIcon,
  'lamp-floor': LampFloorIcon,
  'lamp-wall-down': LampWallDownIcon,
  'lamp-wall-up': LampWallUpIcon,
  'land-plot': LandPlotIcon,
  'landmark': LandmarkIcon,
  'languages': LanguagesIcon,
  'laptop': LaptopIcon,
  'laptop-minimal': Laptop2Icon,
  'lasso': LassoIcon,
  'lasso-select': LassoSelectIcon,
  'laugh': LaughIcon,
  'layers': LayersIcon,
  'layers-2': Layers2Icon,
  'layers-3': Layers3Icon,
  'layout-dashboard': LayoutDashboardIcon,
  'layout-grid': LayoutGridIcon,
  'layout-list': LayoutListIcon,
  'layout-panel-left': LayoutPanelLeftIcon,
  'layout-panel-top': LayoutPanelTopIcon,
  'layout-template': LayoutTemplateIcon,
  'leaf': LeafIcon,
  'leafy-green': LeafyGreenIcon,
  'library': LibraryIcon,
  'library-big': LibraryBigIcon,
  'life-buoy': LifeBuoyIcon,
  'ligature': LigatureIcon,
  'lightbulb': LightbulbIcon,
  'lightbulb-off': LightbulbOffIcon,
  'line-chart': LineChartIcon,
  'link': LinkIcon,
  'link-2': Link2Icon,
  'link-2-off': Link2OffIcon,
  'linkedin': LinkedinIcon,
  'list': ListIcon,
  'list-checks': ListChecksIcon,
  'list-collapse': ListCollapseIcon,
  'list-end': ListEndIcon,
  'list-filter': ListFilterIcon,
  'list-minus': ListMinusIcon,
  'list-music': ListMusicIcon,
  'list-ordered': ListOrderedIcon,
  'list-plus': ListPlusIcon,
  'list-restart': ListRestartIcon,
  'list-start': ListStartIcon,
  'list-todo': ListTodoIcon,
  'list-tree': ListTreeIcon,
  'list-video': ListVideoIcon,
  'list-x': ListXIcon,
  'loader': LoaderIcon,
  'loader-circle': Loader2Icon,
  'loader-pinwheel': LoaderPinwheelIcon,
  'locate': LocateIcon,
  'locate-fixed': LocateFixedIcon,
  'locate-off': LocateOffIcon,
  'lock': LockIcon,
  'lock-keyhole': LockKeyholeIcon,
  'lock-keyhole-open': LockKeyholeOpenIcon,
  'lock-open': LockOpenIcon,
  'log-in': LogInIcon,
  'log-out': LogOutIcon,
  'lollipop': LollipopIcon,
  'luggage': LuggageIcon,
  'magnet': MagnetIcon,
  'mail': MailIcon,
  'mail-check': MailCheckIcon,
  'mail-minus': MailMinusIcon,
  'mail-open': MailOpenIcon,
  'mail-plus': MailPlusIcon,
  'mail-question': MailQuestionIcon,
  'mail-search': MailSearchIcon,
  'mail-warning': MailWarningIcon,
  'mail-x': MailXIcon,
  'mailbox': MailboxIcon,
  'mails': MailsIcon,
  'map': MapIcon,
  'map-pin': MapPinIcon,
  'map-pin-off': MapPinOffIcon,
  'map-pinned': MapPinnedIcon,
  'martini': MartiniIcon,
  'maximize': MaximizeIcon,
  'maximize-2': Maximize2Icon,
  'medal': MedalIcon,
  'megaphone': MegaphoneIcon,
  'megaphone-off': MegaphoneOffIcon,
  'meh': MehIcon,
  'memory-stick': MemoryStickIcon,
  'menu': MenuIcon,
  'merge': MergeIcon,
  'message-circle': MessageCircleIcon,
  'message-circle-code': MessageCircleCodeIcon,
  'message-circle-dashed': MessageCircleDashedIcon,
  'message-circle-heart': MessageCircleHeartIcon,
  'message-circle-more': MessageCircleMoreIcon,
  'message-circle-off': MessageCircleOffIcon,
  'message-circle-plus': MessageCirclePlusIcon,
  'message-circle-question': MessageCircleQuestionIcon,
  'message-circle-reply': MessageCircleReplyIcon,
  'message-circle-warning': MessageCircleWarningIcon,
  'message-circle-x': MessageCircleXIcon,
  'message-square': MessageSquareIcon,
  'message-square-code': MessageSquareCodeIcon,
  'message-square-dashed': MessageSquareDashedIcon,
  'message-square-diff': MessageSquareDiffIcon,
  'message-square-dot': MessageSquareDotIcon,
  'message-square-heart': MessageSquareHeartIcon,
  'message-square-more': MessageSquareMoreIcon,
  'message-square-off': MessageSquareOffIcon,
  'message-square-plus': MessageSquarePlusIcon,
  'message-square-quote': MessageSquareQuoteIcon,
  'message-square-reply': MessageSquareReplyIcon,
  'message-square-share': MessageSquareShareIcon,
  'message-square-text': MessageSquareTextIcon,
  'message-square-warning': MessageSquareWarningIcon,
  'message-square-x': MessageSquareXIcon,
  'messages-square': MessagesSquareIcon,
  'mic': MicIcon,
  'mic-off': MicOffIcon,
  'mic-vocal': Mic2Icon,
  'microscope': MicroscopeIcon,
  'microwave': MicrowaveIcon,
  'milestone': MilestoneIcon,
  'milk': MilkIcon,
  'milk-off': MilkOffIcon,
  'minimize': MinimizeIcon,
  'minimize-2': Minimize2Icon,
  'minus': MinusIcon,
  'monitor': MonitorIcon,
  'monitor-check': MonitorCheckIcon,
  'monitor-dot': MonitorDotIcon,
  'monitor-down': MonitorDownIcon,
  'monitor-off': MonitorOffIcon,
  'monitor-pause': MonitorPauseIcon,
  'monitor-play': MonitorPlayIcon,
  'monitor-smartphone': MonitorSmartphoneIcon,
  'monitor-speaker': MonitorSpeakerIcon,
  'monitor-stop': MonitorStopIcon,
  'monitor-up': MonitorUpIcon,
  'monitor-x': MonitorXIcon,
  'moon': MoonIcon,
  'moon-star': MoonStarIcon,
  'mountain': MountainIcon,
  'mountain-snow': MountainSnowIcon,
  'mouse': MouseIcon,
  'mouse-off': MouseOffIcon,
  'mouse-pointer': MousePointerIcon,
  'mouse-pointer-2': MousePointer2Icon,
  'mouse-pointer-ban': MousePointerBanIcon,
  'mouse-pointer-click': MousePointerClickIcon,
  'move': MoveIcon,
  'move-3d': Move3DIcon,
  'move-diagonal': MoveDiagonalIcon,
  'move-diagonal-2': MoveDiagonal2Icon,
  'move-down': MoveDownIcon,
  'move-down-left': MoveDownLeftIcon,
  'move-down-right': MoveDownRightIcon,
  'move-horizontal': MoveHorizontalIcon,
  'move-left': MoveLeftIcon,
  'move-right': MoveRightIcon,
  'move-up': MoveUpIcon,
  'move-up-left': MoveUpLeftIcon,
  'move-up-right': MoveUpRightIcon,
  'move-vertical': MoveVerticalIcon,
  'music': MusicIcon,
  'music-2': Music2Icon,
  'music-3': Music3Icon,
  'music-4': Music4Icon,
  'navigation': NavigationIcon,
  'navigation-2': Navigation2Icon,
  'navigation-2-off': Navigation2OffIcon,
  'navigation-off': NavigationOffIcon,
  'network': NetworkIcon,
  'newspaper': NewspaperIcon,
  'nfc': NfcIcon,
  'notebook': NotebookIcon,
  'notebook-pen': NotebookPenIcon,
  'notebook-tabs': NotebookTabsIcon,
  'notebook-text': NotebookTextIcon,
  'notepad-text': NotepadTextIcon,
  'notepad-text-dashed': NotepadTextDashedIcon,
  'nut': NutIcon,
  'nut-off': NutOffIcon,
  'octagon': OctagonIcon,
  'octagon-alert': AlertOctagonIcon,
  'octagon-pause': OctagonPauseIcon,
  'octagon-x': OctagonXIcon,
  'option': OptionIcon,
  'orbit': OrbitIcon,
  'origami': OrigamiIcon,
  'package': PackageIcon,
  'package-2': Package2Icon,
  'package-check': PackageCheckIcon,
  'package-minus': PackageMinusIcon,
  'package-open': PackageOpenIcon,
  'package-plus': PackagePlusIcon,
  'package-search': PackageSearchIcon,
  'package-x': PackageXIcon,
  'paint-bucket': PaintBucketIcon,
  'paint-roller': PaintRollerIcon,
  'paintbrush': PaintbrushIcon,
  'paintbrush-2': Paintbrush2Icon,
  'palette': PaletteIcon,
  'panel-bottom': PanelBottomIcon,
  'panel-bottom-close': PanelBottomCloseIcon,
  'panel-bottom-dashed': PanelBottomDashedIcon,
  'panel-bottom-open': PanelBottomOpenIcon,
  'panel-left': PanelLeftIcon,
  'panel-left-close': PanelLeftCloseIcon,
  'panel-left-dashed': PanelLeftDashedIcon,
  'panel-left-open': PanelLeftOpenIcon,
  'panel-right': PanelRightIcon,
  'panel-right-close': PanelRightCloseIcon,
  'panel-right-dashed': PanelRightDashedIcon,
  'panel-right-open': PanelRightOpenIcon,
  'panel-top': PanelTopIcon,
  'panel-top-close': PanelTopCloseIcon,
  'panel-top-dashed': PanelTopDashedIcon,
  'panel-top-open': PanelTopOpenIcon,
  'panels-left-bottom': PanelsLeftBottomIcon,
  'panels-right-bottom': PanelsRightBottomIcon,
  'panels-top-left': LayoutIcon,
  'paperclip': PaperclipIcon,
  'parentheses': ParenthesesIcon,
  'parking-meter': ParkingMeterIcon,
  'party-popper': PartyPopperIcon,
  'pause': PauseIcon,
  'paw-print': PawPrintIcon,
  'pc-case': PcCaseIcon,
  'pen': Edit2Icon,
  'pen-line': Edit3Icon,
  'pen-tool': PenToolIcon,
  'pencil': PencilIcon,
  'pencil-line': PencilLineIcon,
  'pencil-ruler': PencilRulerIcon,
  'pentagon': PentagonIcon,
  'percent': PercentIcon,
  'person-standing': PersonStandingIcon,
  'phone': PhoneIcon,
  'phone-call': PhoneCallIcon,
  'phone-forwarded': PhoneForwardedIcon,
  'phone-incoming': PhoneIncomingIcon,
  'phone-missed': PhoneMissedIcon,
  'phone-off': PhoneOffIcon,
  'phone-outgoing': PhoneOutgoingIcon,
  'pi': PiIcon,
  'piano': PianoIcon,
  'pickaxe': PickaxeIcon,
  'picture-in-picture': PictureInPictureIcon,
  'picture-in-picture-2': PictureInPicture2Icon,
  'pie-chart': PieChartIcon,
  'piggy-bank': PiggyBankIcon,
  'pilcrow': PilcrowIcon,
  'pilcrow-left': PilcrowLeftIcon,
  'pilcrow-right': PilcrowRightIcon,
  'pill': PillIcon,
  'pin': PinIcon,
  'pin-off': PinOffIcon,
  'pipette': PipetteIcon,
  'pizza': PizzaIcon,
  'plane': PlaneIcon,
  'plane-landing': PlaneLandingIcon,
  'plane-takeoff': PlaneTakeoffIcon,
  'play': PlayIcon,
  'plug': PlugIcon,
  'plug-2': Plug2Icon,
  'plug-zap': PlugZapIcon,
  'plug-zap-2': PlugZap2Icon,
  'plus': PlusIcon,
  'pocket': PocketIcon,
  'pocket-knife': PocketKnifeIcon,
  'podcast': PodcastIcon,
  'pointer': PointerIcon,
  'pointer-off': PointerOffIcon,
  'popcorn': PopcornIcon,
  'popsicle': PopsicleIcon,
  'pound-sterling': PoundSterlingIcon,
  'power': PowerIcon,
  'power-off': PowerOffIcon,
  'presentation': PresentationIcon,
  'printer': PrinterIcon,
  'projector': ProjectorIcon,
  'proportions': ProportionsIcon,
  'puzzle': PuzzleIcon,
  'pyramid': PyramidIcon,
  'qr-code': QrCodeIcon,
  'quote': QuoteIcon,
  'rabbit': RabbitIcon,
  'radar': RadarIcon,
  'radiation': RadiationIcon,
  'radical': RadicalIcon,
  'radio': RadioIcon,
  'radio-receiver': RadioReceiverIcon,
  'radio-tower': RadioTowerIcon,
  'radius': RadiusIcon,
  'rail-symbol': RailSymbolIcon,
  'rainbow': RainbowIcon,
  'rat': RatIcon,
  'ratio': RatioIcon,
  'receipt': ReceiptIcon,
  'receipt-cent': ReceiptCentIcon,
  'receipt-euro': ReceiptEuroIcon,
  'receipt-indian-rupee': ReceiptIndianRupeeIcon,
  'receipt-japanese-yen': ReceiptJapaneseYenIcon,
  'receipt-pound-sterling': ReceiptPoundSterlingIcon,
  'receipt-russian-ruble': ReceiptRussianRubleIcon,
  'receipt-swiss-franc': ReceiptSwissFrancIcon,
  'receipt-text': ReceiptTextIcon,
  'rectangle-ellipsis': FormInputIcon,
  'rectangle-horizontal': RectangleHorizontalIcon,
  'rectangle-vertical': RectangleVerticalIcon,
  'recycle': RecycleIcon,
  'redo': RedoIcon,
  'redo-2': Redo2Icon,
  'redo-dot': RedoDotIcon,
  'refresh-ccw': RefreshCcwIcon,
  'refresh-ccw-dot': RefreshCcwDotIcon,
  'refresh-cw': RefreshCwIcon,
  'refresh-cw-off': RefreshCwOffIcon,
  'refrigerator': RefrigeratorIcon,
  'regex': RegexIcon,
  'remove-formatting': RemoveFormattingIcon,
  'repeat': RepeatIcon,
  'repeat-1': Repeat1Icon,
  'repeat-2': Repeat2Icon,
  'replace': ReplaceIcon,
  'replace-all': ReplaceAllIcon,
  'reply': ReplyIcon,
  'reply-all': ReplyAllIcon,
  'rewind': RewindIcon,
  'ribbon': RibbonIcon,
  'rocket': RocketIcon,
  'rocking-chair': RockingChairIcon,
  'roller-coaster': RollerCoasterIcon,
  'rotate-3d': Rotate3DIcon,
  'rotate-ccw': RotateCcwIcon,
  'rotate-ccw-square': RotateCcwSquareIcon,
  'rotate-cw': RotateCwIcon,
  'rotate-cw-square': RotateCwSquareIcon,
  'route': RouteIcon,
  'route-off': RouteOffIcon,
  'router': RouterIcon,
  'rows-2': Rows2Icon,
  'rows-3': PanelsTopBottomIcon,
  'rows-4': Rows4Icon,
  'rss': RssIcon,
  'ruler': RulerIcon,
  'russian-ruble': RussianRubleIcon,
  'sailboat': SailboatIcon,
  'salad': SaladIcon,
  'sandwich': SandwichIcon,
  'satellite': SatelliteIcon,
  'satellite-dish': SatelliteDishIcon,
  'save': SaveIcon,
  'save-all': SaveAllIcon,
  'scale': ScaleIcon,
  'scale-3d': Scale3DIcon,
  'scaling': ScalingIcon,
  'scan': ScanIcon,
  'scan-barcode': ScanBarcodeIcon,
  'scan-eye': ScanEyeIcon,
  'scan-face': ScanFaceIcon,
  'scan-line': ScanLineIcon,
  'scan-search': ScanSearchIcon,
  'scan-text': ScanTextIcon,
  'scatter-chart': ScatterChartIcon,
  'school': SchoolIcon,
  'scissors': ScissorsIcon,
  'scissors-line-dashed': ScissorsLineDashedIcon,
  'screen-share': ScreenShareIcon,
  'screen-share-off': ScreenShareOffIcon,
  'scroll': ScrollIcon,
  'scroll-text': ScrollTextIcon,
  'search': SearchIcon,
  'search-check': SearchCheckIcon,
  'search-code': SearchCodeIcon,
  'search-slash': SearchSlashIcon,
  'search-x': SearchXIcon,
  'send': SendIcon,
  'send-horizontal': SendHorizonalIcon,
  'send-to-back': SendToBackIcon,
  'separator-horizontal': SeparatorHorizontalIcon,
  'separator-vertical': SeparatorVerticalIcon,
  'server': ServerIcon,
  'server-cog': ServerCogIcon,
  'server-crash': ServerCrashIcon,
  'server-off': ServerOffIcon,
  'settings': SettingsIcon,
  'settings-2': Settings2Icon,
  'shapes': ShapesIcon,
  'share': ShareIcon,
  'share-2': Share2Icon,
  'sheet': SheetIcon,
  'shell': ShellIcon,
  'shield': ShieldIcon,
  'shield-alert': ShieldAlertIcon,
  'shield-ban': ShieldBanIcon,
  'shield-check': ShieldCheckIcon,
  'shield-ellipsis': ShieldEllipsisIcon,
  'shield-half': ShieldHalfIcon,
  'shield-minus': ShieldMinusIcon,
  'shield-off': ShieldOffIcon,
  'shield-plus': ShieldPlusIcon,
  'shield-question': ShieldQuestionIcon,
  'shield-x': ShieldCloseIcon,
  'ship': ShipIcon,
  'ship-wheel': ShipWheelIcon,
  'shirt': ShirtIcon,
  'shopping-bag': ShoppingBagIcon,
  'shopping-basket': ShoppingBasketIcon,
  'shopping-cart': ShoppingCartIcon,
  'shovel': ShovelIcon,
  'shower-head': ShowerHeadIcon,
  'shrink': ShrinkIcon,
  'shrub': ShrubIcon,
  'shuffle': ShuffleIcon,
  'sigma': SigmaIcon,
  'signal': SignalIcon,
  'signal-high': SignalHighIcon,
  'signal-low': SignalLowIcon,
  'signal-medium': SignalMediumIcon,
  'signal-zero': SignalZeroIcon,
  'signpost': SignpostIcon,
  'signpost-big': SignpostBigIcon,
  'siren': SirenIcon,
  'skip-back': SkipBackIcon,
  'skip-forward': SkipForwardIcon,
  'skull': SkullIcon,
  'slack': SlackIcon,
  'slash': SlashIcon,
  'slice': SliceIcon,
  'sliders-horizontal': SlidersHorizontalIcon,
  'sliders-vertical': SlidersIcon,
  'smartphone': SmartphoneIcon,
  'smartphone-charging': SmartphoneChargingIcon,
  'smartphone-nfc': SmartphoneNfcIcon,
  'smile': SmileIcon,
  'smile-plus': SmilePlusIcon,
  'snail': SnailIcon,
  'snowflake': SnowflakeIcon,
  'sofa': SofaIcon,
  'soup': SoupIcon,
  'space': SpaceIcon,
  'spade': SpadeIcon,
  'sparkle': SparkleIcon,
  'sparkles': SparklesIcon,
  'speaker': SpeakerIcon,
  'speech': SpeechIcon,
  'spell-check': SpellCheckIcon,
  'spell-check-2': SpellCheck2Icon,
  'spline': SplineIcon,
  'split': SplitIcon,
  'spray-can': SprayCanIcon,
  'sprout': SproutIcon,
  'square': SquareIcon,
  'square-activity': ActivitySquareIcon,
  'square-arrow-down': ArrowDownSquareIcon,
  'square-arrow-down-left': ArrowDownLeftSquareIcon,
  'square-arrow-down-right': ArrowDownRightSquareIcon,
  'square-arrow-left': ArrowLeftSquareIcon,
  'square-arrow-out-down-left': ArrowDownLeftFromSquareIcon,
  'square-arrow-out-down-right': ArrowDownRightFromSquareIcon,
  'square-arrow-out-up-left': ArrowUpLeftFromSquareIcon,
  'square-arrow-out-up-right': ArrowUpRightFromSquareIcon,
  'square-arrow-right': ArrowRightSquareIcon,
  'square-arrow-up': ArrowUpSquareIcon,
  'square-arrow-up-left': ArrowUpLeftSquareIcon,
  'square-arrow-up-right': ArrowUpRightSquareIcon,
  'square-asterisk': AsteriskSquareIcon,
  'square-bottom-dashed-scissors': ScissorsSquareDashedBottomIcon,
  'square-check': CheckSquare2Icon,
  'square-check-big': CheckSquareIcon,
  'square-chevron-down': ChevronDownSquareIcon,
  'square-chevron-left': ChevronLeftSquareIcon,
  'square-chevron-right': ChevronRightSquareIcon,
  'square-chevron-up': ChevronUpSquareIcon,
  'square-code': CodeSquareIcon,
  'square-dashed-bottom': SquareDashedBottomIcon,
  'square-dashed-bottom-code': SquareDashedBottomCodeIcon,
  'square-dashed-kanban': KanbanSquareDashedIcon,
  'square-dashed-mouse-pointer': MousePointerSquareDashedIcon,
  'square-divide': DivideSquareIcon,
  'square-dot': DotSquareIcon,
  'square-equal': EqualSquareIcon,
  'square-function': FunctionSquareIcon,
  'square-gantt-chart': GanttChartSquareIcon,
  'square-kanban': KanbanSquareIcon,
  'square-library': LibrarySquareIcon,
  'square-m': MSquareIcon,
  'square-menu': MenuSquareIcon,
  'square-minus': MinusSquareIcon,
  'square-mouse-pointer': InspectIcon,
  'square-parking': ParkingSquareIcon,
  'square-parking-off': ParkingSquareOffIcon,
  'square-pen': EditIcon,
  'square-percent': PercentSquareIcon,
  'square-pi': PiSquareIcon,
  'square-pilcrow': PilcrowSquareIcon,
  'square-play': PlaySquareIcon,
  'square-plus': PlusSquareIcon,
  'square-power': PowerSquareIcon,
  'square-radical': SquareRadicalIcon,
  'square-scissors': ScissorsSquareIcon,
  'square-sigma': SigmaSquareIcon,
  'square-slash': SlashSquareIcon,
  'square-split-horizontal': SplitSquareHorizontalIcon,
  'square-split-vertical': SplitSquareVerticalIcon,
  'square-stack': SquareStackIcon,
  'square-terminal': SquareTerminalIcon,
  'square-user': SquareUserIcon,
  'square-user-round': SquareUserRoundIcon,
  'square-x': SquareXIcon,
  'squircle': SquircleIcon,
  'squirrel': SquirrelIcon,
  'stamp': StampIcon,
  'star': StarIcon,
  'star-half': StarHalfIcon,
  'star-off': StarOffIcon,
  'step-back': StepBackIcon,
  'step-forward': StepForwardIcon,
  'stethoscope': StethoscopeIcon,
  'sticker': StickerIcon,
  'sticky-note': StickyNoteIcon,
  'store': StoreIcon,
  'stretch-horizontal': StretchHorizontalIcon,
  'stretch-vertical': StretchVerticalIcon,
  'strikethrough': StrikethroughIcon,
  'subscript': SubscriptIcon,
  'sun': SunIcon,
  'sun-dim': SunDimIcon,
  'sun-medium': SunMediumIcon,
  'sun-moon': SunMoonIcon,
  'sun-snow': SunSnowIcon,
  'sunrise': SunriseIcon,
  'sunset': SunsetIcon,
  'superscript': SuperscriptIcon,
  'swatch-book': SwatchBookIcon,
  'swiss-franc': SwissFrancIcon,
  'switch-camera': SwitchCameraIcon,
  'sword': SwordIcon,
  'swords': SwordsIcon,
  'syringe': SyringeIcon,
  'table': TableIcon,
  'table-2': Table2Icon,
  'table-cells-merge': TableCellsMergeIcon,
  'table-cells-split': TableCellsSplitIcon,
  'table-columns-split': TableColumnsSplitIcon,
  'table-properties': TablePropertiesIcon,
  'table-rows-split': TableRowsSplitIcon,
  'tablet': TabletIcon,
  'tablet-smartphone': TabletSmartphoneIcon,
  'tablets': TabletsIcon,
  'tag': TagIcon,
  'tags': TagsIcon,
  'tally-1': Tally1Icon,
  'tally-2': Tally2Icon,
  'tally-3': Tally3Icon,
  'tally-4': Tally4Icon,
  'tally-5': Tally5Icon,
  'tangent': TangentIcon,
  'target': TargetIcon,
  'telescope': TelescopeIcon,
  'tent': TentIcon,
  'tent-tree': TentTreeIcon,
  'terminal': TerminalIcon,
  'test-tube': TestTubeIcon,
  'test-tube-diagonal': TestTube2Icon,
  'test-tubes': TestTubesIcon,
  'text': TextIcon,
  'text-cursor': TextCursorIcon,
  'text-cursor-input': TextCursorInputIcon,
  'text-quote': TextQuoteIcon,
  'text-search': TextSearchIcon,
  'text-select': TextSelectIcon,
  'theater': TheaterIcon,
  'thermometer': ThermometerIcon,
  'thermometer-snowflake': ThermometerSnowflakeIcon,
  'thermometer-sun': ThermometerSunIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  'ticket': TicketIcon,
  'ticket-check': TicketCheckIcon,
  'ticket-minus': TicketMinusIcon,
  'ticket-percent': TicketPercentIcon,
  'ticket-plus': TicketPlusIcon,
  'ticket-slash': TicketSlashIcon,
  'ticket-x': TicketXIcon,
  'timer': TimerIcon,
  'timer-off': TimerOffIcon,
  'timer-reset': TimerResetIcon,
  'toggle-left': ToggleLeftIcon,
  'toggle-right': ToggleRightIcon,
  'tornado': TornadoIcon,
  'torus': TorusIcon,
  'touchpad': TouchpadIcon,
  'touchpad-off': TouchpadOffIcon,
  'tower-control': TowerControlIcon,
  'toy-brick': ToyBrickIcon,
  'tractor': TractorIcon,
  'traffic-cone': TrafficConeIcon,
  'train-front': TrainFrontIcon,
  'train-front-tunnel': TrainFrontTunnelIcon,
  'train-track': TrainTrackIcon,
  'tram-front': TrainIcon,
  'trash': TrashIcon,
  'trash-2': Trash2Icon,
  'tree-deciduous': TreeDeciduousIcon,
  'tree-palm': PalmtreeIcon,
  'tree-pine': TreePineIcon,
  'trees': TreesIcon,
  'trello': TrelloIcon,
  'trending-down': TrendingDownIcon,
  'trending-up': TrendingUpIcon,
  'triangle': TriangleIcon,
  'triangle-alert': AlertTriangleIcon,
  'triangle-right': TriangleRightIcon,
  'trophy': TrophyIcon,
  'truck': TruckIcon,
  'turtle': TurtleIcon,
  'tv': TvIcon,
  'tv-2': Tv2Icon,
  'twitch': TwitchIcon,
  'twitter': TwitterIcon,
  'type': TypeIcon,
  'umbrella': UmbrellaIcon,
  'umbrella-off': UmbrellaOffIcon,
  'underline': UnderlineIcon,
  'undo': UndoIcon,
  'undo-2': Undo2Icon,
  'undo-dot': UndoDotIcon,
  'unfold-horizontal': UnfoldHorizontalIcon,
  'unfold-vertical': UnfoldVerticalIcon,
  'ungroup': UngroupIcon,
  'university': School2Icon,
  'unlink': UnlinkIcon,
  'unlink-2': Unlink2Icon,
  'unplug': UnplugIcon,
  'upload': UploadIcon,
  'usb': UsbIcon,
  'user': UserIcon,
  'user-check': UserCheckIcon,
  'user-cog': UserCogIcon,
  'user-minus': UserMinusIcon,
  'user-plus': UserPlusIcon,
  'user-round': User2Icon,
  'user-round-check': UserCheck2Icon,
  'user-round-cog': UserCog2Icon,
  'user-round-minus': UserMinus2Icon,
  'user-round-plus': UserPlus2Icon,
  'user-round-search': UserRoundSearchIcon,
  'user-round-x': UserRoundXIcon,
  'user-search': UserSearchIcon,
  'user-x': UserXIcon,
  'users': UsersIcon,
  'users-round': Users2Icon,
  'utensils': UtensilsIcon,
  'utensils-crossed': UtensilsCrossedIcon,
  'utility-pole': UtilityPoleIcon,
  'variable': VariableIcon,
  'vault': VaultIcon,
  'vegan': VeganIcon,
  'venetian-mask': VenetianMaskIcon,
  'vibrate': VibrateIcon,
  'vibrate-off': VibrateOffIcon,
  'video': VideoIcon,
  'video-off': VideoOffIcon,
  'videotape': VideotapeIcon,
  'view': ViewIcon,
  'voicemail': VoicemailIcon,
  'volume': VolumeIcon,
  'volume-1': Volume1Icon,
  'volume-2': Volume2Icon,
  'volume-x': VolumeXIcon,
  'vote': VoteIcon,
  'wallet': WalletIcon,
  'wallet-cards': WalletCardsIcon,
  'wallet-minimal': Wallet2Icon,
  'wallpaper': WallpaperIcon,
  'wand': WandIcon,
  'wand-sparkles': Wand2Icon,
  'warehouse': WarehouseIcon,
  'washing-machine': WashingMachineIcon,
  'watch': WatchIcon,
  'waves': WavesIcon,
  'waypoints': WaypointsIcon,
  'webcam': WebcamIcon,
  'webhook': WebhookIcon,
  'webhook-off': WebhookOffIcon,
  'weight': WeightIcon,
  'wheat': WheatIcon,
  'wheat-off': WheatOffIcon,
  'whole-word': WholeWordIcon,
  'wifi': WifiIcon,
  'wifi-off': WifiOffIcon,
  'wind': WindIcon,
  'wine': WineIcon,
  'wine-off': WineOffIcon,
  'workflow': WorkflowIcon,
  'worm': WormIcon,
  'wrap-text': WrapTextIcon,
  'wrench': WrenchIcon,
  'x': XIcon,
  'youtube': YoutubeIcon,
  'zap': ZapIcon,
  'zap-off': ZapOffIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
};

export function getAppIcon(key: string | null | undefined): LucideIcon {
  if (key && key in APP_ICONS) return APP_ICONS[key as AppIconKey];
  return APP_ICONS[DEFAULT_APP_ICON];
}

/** Whether a given string is one of the valid icon keys. */
export function isAppIconKey(key: string): key is AppIconKey {
  return (APP_ICON_KEYS as readonly string[]).includes(key);
}
